import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import TransactionModal from './TransactionModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { FaFilter, FaEye } from "react-icons/fa";
import { Dropdown, InputGroup, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { FiDownload, FiMoreVertical, FiSearch, FiArrowUp, FiArrowDown } from 'react-icons/fi';
import { displayConvertedAmount } from '../../../utils/currencyConverter';

const TransactionList = () => {
    const [transactions, setTransactions] = useState([]);
    const [lockedPeriods, setLockedPeriods] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const formatCurrency = (amount, transaction = null) => {
        // Priority: transaction_currency_code (from list API) > currency.currency (from detail API) > account base currency > AED
        const currency = transaction?.transaction_currency_code ||
                         transaction?.currency?.currency ||
                         transaction?.account?.base_currency?.currency ||
                         null;
        const formattedNum = Number(amount || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        // If no currency resolved, show plain number (don't hardcode AED)
        return currency ? `${currency} ${formattedNum}` : formattedNum;
    };

    const formatTooltipCurrency = (amount, transaction) => {
        return formatCurrency(amount, transaction);
    };

    const getTooltipSign = (transaction) => {
        const type = (transaction.type || "").toLowerCase();
        const advType = (transaction.advance_type || "").toLowerCase();
        
        const isMoneyIn = ['income', 'receipt', 'capital', 'bank_guarantee_released'].includes(type) || 
                         (type === 'advance' && (advType === 'client' || advType === 'advance_receipt'));
        
        return isMoneyIn ? '-' : '+';
    };

    const getTooltipNetTotal = (transaction) => {
        const amount = Number(transaction.amount || 0);
        const charges = Number(transaction.bank_service_charge || 0) + 
                       Number(transaction.bank_vat_amount || 0) +
                       Number(transaction.other_bank_service_charge || 0);
        
        const type = (transaction.type || "").toLowerCase();
        const advType = (transaction.advance_type || "").toLowerCase();
        const isMoneyIn = ['income', 'receipt', 'capital', 'bank_guarantee_released'].includes(type) || 
                         (type === 'advance' && (advType === 'client' || advType === 'advance_receipt'));
        
        if (isMoneyIn) return amount - charges;
        
        // Money out logic
        // For money out, transaction.amount already represents the total cash flow (including all charges)
        return amount;
    };
    const [loading, setLoading] = useState(false);
    const [selectedTransactionId, setSelectedTransactionId] = useState(null);
    const [selectedTransactionData, setSelectedTransactionData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [errors, setErrors] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const firstLoad = useRef(true);
    const { roles, permissions } = useAuth();
    const [allTransactions, setAllTransactions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [banks, setBanks] = useState([]);
    const [clients, setClients] = useState([]);
    const [projects, setProjects] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [bankFilter, setBankFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const [transactionTypeFilter, setTransactionTypeFilter] = useState('');
    const [showUncategorized, setShowUncategorized] = useState(false);
    const lastFetchedParamsRef = useRef(null);
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [vendorExpenses, setVendorExpenses] = useState([]); // To store vendor-specific expenses
    const [selectedVendorExpenses, setSelectedVendorExpenses] = useState([]);
    const [extenseType, setExpenseType] = useState('');
    const [selectedTab, setSelectedTab] = useState('transactions');
    const [vatData, setVatData] = useState([])
    const [invatData, setInVatData] = useState([])
    const [ouvatData, setOuVatData] = useState([])
    const [selectedQuarterLabel, setSelectedQuarterLabel] = useState('');
    const [vatSettings, setVatSettings] = useState({});
    const [quarterOptions, setQuarterOptions] = useState([]);
    const [users, setUsers] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedYear, setSelectedYear] = useState(null);
    const [inputVatPagination, setInputVatPagination] = useState({
        currentPage: 0,
        pageCount: 0,
        totalItems: 0
    });
    const [activeTab, setActiveTab] = useState('transactions'); // or 'input-vat' / 'output-vat'
    const [accountingLockMessage, setAccountingLockMessage] = useState('');
    const [pagedOpeningBalance, setPagedOpeningBalance] = useState(null);
    const [balanceHistoryCache, setBalanceHistoryCache] = useState({}); // { [page_bank_key]: balance }
    const [ledgerBalancesMap, setLedgerBalancesMap] = useState({}); // { [entry_id]: running_balance }
    const [newlyAddedId, setNewlyAddedId] = useState(null);



    const [outputVatPagination, setOutputVatPagination] = useState({
        currentPage: 0,
        pageCount: 0,
        totalItems: 0
    });
    const [summaryData, setSummaryData] = useState({
        totalIncome: 0,
        totalExpense: 0,
        totalCapital: 0,
        totalAdvance: 0,
        totalPayroll: 0,
        totalContra: 0,
        totalVatPayable: 0,
        totalWithdrawal: 0,
        grandTotal: 0,
        filteredCount: 0,
        dateRange: ''
    });
    const [moneyTypeFilter, setMoneyTypeFilter] = useState('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [applyFilterClicked, setApplyFilterClicked] = useState(false);
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [dateRangeFilter, setDateRangeFilter] = useState('yearly');
    const [showSummaryBox, setShowSummaryBox] = useState(true);

    const [selectedEndYear, setSelectedEndYear] = useState(null);

    const handleDateRangeChange = (value) => {
        setDateRangeFilter(value);
        const now = dayjs();
        setSelectedYear(now);
        setSelectedEndYear(now);
        
        if (value === 'yearly') {
            setStartDateFilter(now.startOf('year').format('YYYY-MM-DD'));
            setEndDateFilter(now.endOf('year').format('YYYY-MM-DD'));
        }
    };

    const getBalanceCacheKey = (bankId, pageIndex) => `${bankId}-${pageIndex}`;
    const hasLedgerScopedFilters = Boolean(bankFilter || startDateFilter || endDateFilter);

    const getServerRunningBalance = (transaction) => {
        const balanceCandidates = [
            transaction?.balance,
            transaction?.current_balance,
            transaction?.running_balance,
        ];

        for (const candidate of balanceCandidates) {
            if (candidate === undefined || candidate === null || candidate === '') continue;

            const parsedValue = Number(candidate);
            if (!Number.isNaN(parsedValue)) {
                return parsedValue;
            }
        }

        return null;
    };

    const getDisplayedRunningBalance = (transaction, index, allTransactions) => {
        // Defensive check: zero amount transaction (like pure advance application) does not affect bank balance
        const cleanAmt = (val) => {
            if (typeof val === 'number') return val;
            if (!val) return 0;
            return parseFloat(String(val).replace(/[^\d.-]/g, '')) || 0;
        };
        let amount = 0;
        if (transaction?.amount !== undefined && transaction?.amount !== null && transaction?.amount !== '') {
            amount = cleanAmt(transaction.amount);
        } else {
            amount = cleanAmt(transaction?.base_amount) || cleanAmt(transaction?.converted_amount);
        }
        const charges = cleanAmt(transaction?.bank_service_charge) + 
                        cleanAmt(transaction?.other_bank_service_charge) +
                        cleanAmt(transaction?.bank_vat_amount) +
                        cleanAmt(transaction?.commission_fee) +
                        cleanAmt(transaction?.commission_vat);

        // For zero-amount transactions (like pure Advance Applied), they don't affect the bank.
        // Return the running balance of the previous transaction for the same bank.
        if (amount === 0 && charges === 0 && index !== undefined && allTransactions !== undefined) {
            const bankId = transaction.account_id || transaction.from_bank_id || transaction.to_bank_id;
            for (let i = index - 1; i >= 0; i--) {
                const prevTxn = allTransactions[i];
                const prevBankId = prevTxn.account_id || prevTxn.from_bank_id || prevTxn.to_bank_id;
                if (String(prevBankId) === String(bankId)) {
                    return getDisplayedRunningBalance(prevTxn, i, allTransactions);
                }
            }
        }

        if (transaction?.entry_id && ledgerBalancesMap[transaction.entry_id] !== undefined) {
            return Number(ledgerBalancesMap[transaction.entry_id]);
        }

        const serverRunningBalance = getServerRunningBalance(transaction);

        // In the unfiltered list, fall back to the API-provided running balance when ledger data is unavailable.
        if (!hasLedgerScopedFilters && serverRunningBalance !== null) {
            return serverRunningBalance;
        }

        if (
            transaction?.calculated_running_balance !== undefined &&
            transaction?.calculated_running_balance !== null
        ) {
            const parsedCalculatedBalance = Number(transaction.calculated_running_balance);
            if (!Number.isNaN(parsedCalculatedBalance)) {
                return parsedCalculatedBalance;
            }
        }

        return serverRunningBalance;
    };

    const transactionsWithBalances = useMemo(() => {
        if (!isDataLoaded || !transactions || transactions.length === 0) return [];
        
        // 1. Initialize Balances for ALL banks
        const getCachedBalanceForBank = (bankId, endPageIndex) => {
            for (let pageIndex = endPageIndex; pageIndex >= -1; pageIndex -= 1) {
                const cacheKey = getBalanceCacheKey(bankId, pageIndex);
                if (balanceHistoryCache[cacheKey] !== undefined) {
                    return parseFloat(balanceHistoryCache[cacheKey]);
                }
            }
            return null;
        };

        const currentBalances = {};
        if (banks && banks.length > 0) {
            banks.forEach(bank => {
                const previousBalance = getCachedBalanceForBank(bank.id, currentPage - 1);

                // Priority 1: apiOpeningBalance (If bankFilter matches)
                if (bankFilter && parseInt(bank.id) === parseInt(bankFilter) && pagedOpeningBalance !== null) {
                    currentBalances[bank.id] = parseFloat(pagedOpeningBalance);
                }
                // Priority 2: balanceHistoryCache (Session memory while browsing or historical date filter)
                else if (previousBalance !== null) {
                    currentBalances[bank.id] = previousBalance;
                }
                // Priority 3: Fallback opening balance
                else {
                    currentBalances[bank.id] = parseFloat(bank.opening_balance || 0) || 0;
                }
            });
        }
        
        // 2. DEFENSIVE PARSING
        const cleanAmount = (val) => {
            if (typeof val === 'number') return val;
            if (!val) return 0;
            const cleaned = String(val).replace(/[^\d.-]/g, '');
            return parseFloat(cleaned) || 0;
        };

        const balancesMap = {};

        // 3. Sort by date ASC (oldest first), then created_at ASC
        const sortedTxns = [...transactions].sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            if (dateA - dateB !== 0) return dateA - dateB;
            const createdA = new Date(a.created_at);
            const createdB = new Date(b.created_at);
            return createdA - createdB;
        });

        // 4. Calculate running balance PER BANK
        sortedTxns.forEach(txn => {
            const actualBankTarget = (txn.account_id || txn.from_bank_id || txn.to_bank_id);
            let bankAccountTarget = actualBankTarget;
            if (bankFilter && String(actualBankTarget) === String(bankFilter)) {
                bankAccountTarget = parseInt(bankFilter);
            }

            let amount = 0;
            if (txn.amount !== undefined && txn.amount !== null && txn.amount !== '') {
                amount = cleanAmount(txn.amount);
            } else {
                amount = cleanAmount(txn.base_amount) || cleanAmount(txn.converted_amount);
            }
            const charges = cleanAmount(txn.bank_service_charge) + 
                          cleanAmount(txn.other_bank_service_charge) +
                          cleanAmount(txn.bank_vat_amount) +
                          cleanAmount(txn.commission_fee) +
                          cleanAmount(txn.commission_vat);

            const rawType = (txn.type || "").toLowerCase().trim();
            const entryTypeId = Number(txn.entrytype_id || 0);
            
            const isMoneyIn = ['income', 'receipt', 'capital', 'bank_guarantee_released'].includes(rawType) || 
                             (rawType === 'advance' && (txn.advance_type === 'client' || txn.advance_type === 'advance_receipt')) ||
                             (entryTypeId === 1);
            
            const isMoneyOut = ['expense', 'payment', 'withdrawal', 'payroll', 'bank_guarantee', 'bank_guarantee_charges', 'bad_debt_written_off', 'vat_payable'].includes(rawType) ||
                               (rawType === 'advance' && (txn.advance_type === 'vendor' || txn.advance_type === 'pettycash' || txn.advance_type === 'advance_payment')) ||
                               (entryTypeId === 2);

            let effect = 0;
            if (rawType === 'contra') {
                if (String(txn.from_bank_id) === String(bankAccountTarget)) effect = -(amount + charges);
                else if (String(txn.to_bank_id) === String(bankAccountTarget)) effect = (amount - charges);
            } else if (isMoneyIn) {
                effect = amount - charges;
            } else if (isMoneyOut) {
                effect = -(amount + charges);
            }
            
            currentBalances[bankAccountTarget] = (currentBalances[bankAccountTarget] || 0) + (effect || 0);
            balancesMap[txn.id] = currentBalances[bankAccountTarget];
        });

        // 4. Return in the SAME sorted order with calculated balances
        return sortedTxns.map(txn => ({
            ...txn,
            calculated_running_balance: balancesMap[txn.id]
        }));
    }, [transactions, banks, isDataLoaded, pagedOpeningBalance, bankFilter, balanceHistoryCache, currentPage]);

    // Store the closing balance of the current page into history cache for the next page
    useEffect(() => {
        if (transactionsWithBalances.length > 0) {
            // Find the last calculated balance for each bank that appeared on this page
            const pageLastBalances = {};
            
            transactionsWithBalances.forEach(txn => {
                const bId = bankFilter ? parseInt(bankFilter) : (txn.account_id || txn.from_bank_id || txn.to_bank_id);
                if (bId) {
                    pageLastBalances[bId] = txn.calculated_running_balance;
                }
            });

            setBalanceHistoryCache(prev => {
                let hasChanges = false;
                const newCacheUpdates = { ...prev };
                
                Object.entries(pageLastBalances).forEach(([bId, balance]) => {
                    const cacheKey = `${bId}-${currentPage}`;
                    if (!Object.is(prev[cacheKey], balance)) {
                        newCacheUpdates[cacheKey] = balance;
                        hasChanges = true;
                    }
                });

                return hasChanges ? newCacheUpdates : prev;
            });
        }
    }, [transactionsWithBalances, currentPage, bankFilter]);

    // Webzash Ledger Integration
    const lastLedgerFetchKeyRef = useRef('');

    useEffect(() => {
        const fetchLedgerBalances = async () => {
            const transactionSignature = (transactions || [])
                .map(txn => `${txn.id}:${txn.entry_id || ''}`)
                .join('|');
            const currentFetchKey = `${bankFilter || ''}|${startDateFilter || ''}|${endDateFilter || ''}|${currentPage}|${transactionSignature}`;

            if (lastLedgerFetchKeyRef.current === currentFetchKey) return;

            if (!banks || banks.length === 0) {
                setLedgerBalancesMap({});
                lastLedgerFetchKeyRef.current = currentFetchKey;
                return;
            }

            try {
                const bankSubset = [];

                if (bankFilter) {
                    const bank = banks.find(b => String(b.id) === String(bankFilter));
                    if (!bank) {
                        setLedgerBalancesMap({});
                        lastLedgerFetchKeyRef.current = currentFetchKey;
                        return;
                    }
                    bankSubset.push(bank);
                } else {
                    const affectedBankIds = new Set();
                    (transactions || []).forEach(txn => {
                        if (txn.account_id) affectedBankIds.add(String(txn.account_id));
                        if (txn.from_bank_id) affectedBankIds.add(String(txn.from_bank_id));
                        if (txn.to_bank_id) affectedBankIds.add(String(txn.to_bank_id));
                    });

                    banks.forEach(bank => {
                        if (affectedBankIds.has(String(bank.id))) {
                            bankSubset.push(bank);
                        }
                    });
                }

                if (!bankSubset.length) {
                    setLedgerBalancesMap({});
                    lastLedgerFetchKeyRef.current = currentFetchKey;
                    return;
                }

                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const bankNames = bankSubset.map(b => b.name);
                const params = { banks: bankNames };
                if (startDateFilter) params.startdate = startDateFilter;
                if (endDateFilter) params.enddate = endDateFilter;

                const stmtRes = await axios.post(`${backendUrl}/api/reports/multiple-ledger-balances`, params, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Accept': 'application/json'
                    },
                    skipLoader: true,
                });

                const entryBalances = stmtRes.data?.data || {};

                setLedgerBalancesMap(entryBalances);
                lastLedgerFetchKeyRef.current = currentFetchKey;
            } catch (err) {
                console.error('Error fetching backend ledger balances:', err);
                setLedgerBalancesMap({});
                lastLedgerFetchKeyRef.current = currentFetchKey;
            }
        };

        fetchLedgerBalances();
    }, [transactions, banks]);

    // Clear cache on major filter changes to ensure fresh calculations
    const handleFilterSubmit = () => {
        fetchTransactions(1, searchQuery, bankFilter, startDateFilter, endDateFilter);
    };

    const isDateInLockedPeriod = (dateStr) => {
        if (!dateStr) return false;
        const date = new Date(dateStr);
        return lockedPeriods.some(period => {
            const start = new Date(period.start_date);
            const end = new Date(period.end_date);
            return date >= start && date <= end;
        });
    };

    const clearFilters = () => {
        setSearchQuery('');
        setBankFilter('');
        setTransactionTypeFilter('');
        setStartDateFilter('');
        setEndDateFilter('');
        fetchTransactions(1);
    };

    useEffect(() => {
        setBalanceHistoryCache({});
    }, [bankFilter, startDateFilter, endDateFilter, transactionTypeFilter]);

    const fetchTransactions = async (page = 1, searchQuery = '', bankId = '', startDate = '', endDate = '') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            try {
                const lpResponse = await axios.get(`${backendUrl}/api/accounting/locked-periods`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setLockedPeriods(lpResponse.data.locked_periods || []);
            } catch (err) {
                console.error("Failed to fetch locked periods", err);
            }

            let params = { page };

            // Only add filters if they exist
            if (searchQuery) params.search = searchQuery;
            if (bankFilter) params.account_id = bankFilter;
            if (transactionTypeFilter === 'petty_cash') {
                params.payment_mode = 'petty_cash';
            } else if (transactionTypeFilter) {
                params.type = transactionTypeFilter;
            }
            if (showUncategorized) params.uncategorised = true;
            if (startDateFilter) params.from = startDateFilter;
            if (endDateFilter) params.to = endDateFilter;
            if (moneyTypeFilter) params.money_type = moneyTypeFilter;
            
            // Consistent sorting: Date ASC (oldest first), then Created At ASC for same date
            params.order_by = 'date';
            params.order_direction = 'asc';
            params.sort_by = 'created_at';
            params.sort_direction = 'asc';

            // Set loading state
            setLoading(true);

            // If we have a date filter on Page 1, we will get the opening balances from the main API response summary
            let calculatedOpening = null;

            const response = await axios.get(`${backendUrl}/api/transactions`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            const { data, current_page, last_page, total } = response.data.data;
            const summary = response.data.summary;
            
            if (page === 1 && startDateFilter && summary && summary.opening_balances) {
                if (bankFilter) {
                    calculatedOpening = summary.opening_balances[bankFilter] || 0;
                } else {
                    const cacheUpdates = {};
                    Object.entries(summary.opening_balances).forEach(([bId, balance]) => {
                        cacheUpdates[getBalanceCacheKey(bId, -1)] = balance;
                    });
                    setBalanceHistoryCache(prev => ({ ...prev, ...cacheUpdates }));
                }
            }

            // Capture paged opening balance from API with multiple fallback keys
            // Prioritize the secret historicalOpening we just calculated if it exists
            const apiOpeningBalance = 
                calculatedOpening !== null ? calculatedOpening :
                (response.data.opening_balance !== undefined ? response.data.opening_balance :
                (response.data.data && response.data.data.opening_balance !== undefined ? response.data.data.opening_balance : 
                (summary && summary.opening_balance !== undefined ? summary.opening_balance :
                (summary && summary.prev_balance !== undefined ? summary.prev_balance :
                (summary && summary.openingBalance !== undefined ? summary.openingBalance :
                (summary && summary.starting_balance !== undefined ? summary.starting_balance : 
                (response.data.starting_balance !== undefined ? response.data.starting_balance : null)))))));

            setTransactions(data);
            setPagedOpeningBalance(apiOpeningBalance);
            // Guard against a missing/null summary from the API so we never
            // overwrite the summaryData state with null (which breaks
            // summaryData.filteredCount etc. in the render below)
            if (summary) {
                setSummaryData(summary); // Ensure summary state is updated for use in reports
            } else {
                calculateSummaryFromData(data);
            }
            setCurrentPage(current_page - 1);
            setPageCount(last_page);

            setIsDataLoaded(true);
            setApplyFilterClicked(false);

        } catch (error) {
            console.error('Error fetching transactions:', error);
        } finally {
            setLoading(false);
        }
    };

    const calculateSummaryFromData = (data) => {
        const summary = {
            totalIncome: 0,
            totalExpense: 0,
            totalCapital: 0,
            totalAdvance: 0,
            totalPayroll: 0,
            totalContra: 0,
            totalVatPayable: 0,
            totalWithdrawal: 0,
            totalBankGuaranteeReleased: 0,
            totalBankGuarantee: 0,
            totalBankGuaranteeCharged: 0,
            grandTotal: 0,
            filteredCount: data.length,
            dateRange: startDateFilter && endDateFilter
                ? (dayjs(startDateFilter).date() === 1 && dayjs(startDateFilter).month() === 0 &&
                   dayjs(endDateFilter).date() === 31 && dayjs(endDateFilter).month() === 11
                    ? `Jan ${dayjs(startDateFilter).format('YYYY')} - Dec ${dayjs(endDateFilter).format('YYYY')}`
                    : `${dayjs(startDateFilter).format('DD MMM YYYY')} to ${dayjs(endDateFilter).format('DD MMM YYYY')}`)
                : 'All Dates'
        };

        const cleanAmount = (val) => parseFloat(val) || 0;

        data.forEach(txn => {
            const amount = cleanAmount(txn.amount);
            const rawType = txn.type;
            const advType = (txn.advance_type || '').toLowerCase();
            
            const charges = cleanAmount(txn.bank_service_charge) + 
                           cleanAmount(txn.other_bank_service_charge) +
                           cleanAmount(txn.bank_vat_amount) +
                           cleanAmount(txn.commission_fee) +
                           cleanAmount(txn.commission_vat) +
                           cleanAmount(txn.wps_charge) +
                           cleanAmount(txn.wps_vat) +
                           cleanAmount(txn.deduction_amount);

            let isMoneyIn = false;
            let isMoneyOut = false;

            if (rawType === 'contra' && bankFilter) {
                if (txn.to_bank_id == bankFilter) isMoneyIn = true;
                else if (txn.from_bank_id == bankFilter) isMoneyOut = true;
            } else if (rawType === 'advance') {
                if (!!txn.vendor_id || advType === 'vendor' || advType === 'pettycash' || advType === 'advance_payment') {
                    isMoneyOut = true;
                } else if (!!txn.client_id || advType === 'client' || advType === 'advance_receipt') {
                    isMoneyIn = true;
                }
            } else {
                isMoneyIn = ['income', 'receipt', 'capital', 'bank_guarantee_released'].includes(rawType);
                isMoneyOut = ['expense', 'payment', 'withdrawal', 'payroll', 'bank_guarantee', 'bank_guarantee_charges', 'bad_debt_written_off', 'vat_payable'].includes(rawType);
            }

            let netAmount = 0;
            if (isMoneyIn) {
                if (rawType === 'contra') {
                    netAmount = amount;
                } else {
                    netAmount = amount - charges;
                }
            } else if (isMoneyOut) {
                netAmount = amount + charges;
            } else {
                netAmount = amount;
            }

            switch (rawType) {
                case 'income': summary.totalIncome += netAmount; break;
                case 'expense': summary.totalExpense += netAmount; break;
                case 'capital': summary.totalCapital += netAmount; break;
                case 'advance': summary.totalAdvance += netAmount; break;
                case 'payroll': summary.totalPayroll += netAmount; break;
                case 'contra': summary.totalContra += netAmount; break;
                case 'vat_payable': summary.totalVatPayable += netAmount; break;
                case 'withdrawal': summary.totalWithdrawal += netAmount; break;
                case 'bank_guarantee': summary.totalBankGuarantee += netAmount; break;
                case 'bank_guarantee_released': summary.totalBankGuaranteeReleased += netAmount; break;
                case 'bank_guarantee_charges': summary.totalBankGuaranteeCharged += netAmount; break;
            }
            summary.grandTotal += netAmount;
        });

        setSummaryData(summary);
    };

    const applyFilters = () => {
        if (!startDateFilter && !endDateFilter && !bankFilter && !transactionTypeFilter && !moneyTypeFilter && !searchQuery) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                icon: 'warning',
                title: 'Please apply at least one filter to load transactions.'
            });
            return;
        }
        setApplyFilterClicked(true);
        fetchTransactions(1);
        setCurrentPage(0);
    };

    const handleResetFilters = () => {
        setSearchQuery('');
        setBankFilter('');
        setTransactionTypeFilter('');
        setShowUncategorized(false);
        setStartDateFilter('');
        setEndDateFilter('');
        setMoneyTypeFilter('');
        setCurrentPage(0);
        setTransactions([]);
        setIsDataLoaded(false);
        setSummaryData({
            totalIncome: 0, totalExpense: 0, totalCapital: 0, totalAdvance: 0, totalPayroll: 0, totalContra: 0,
            totalVatPayable: 0, totalWithdrawal: 0, totalBankGuaranteeReleased: 0, totalBankGuarantee: 0,
            totalBankGuaranteeCharged: 0, grandTotal: 0, filteredCount: 0, dateRange: 'All Dates'
        });
    };

    const clearAllFilters = () => {
        setStartDateFilter('');
        setEndDateFilter('');
        setSearchQuery('');
        setBankFilter('');
        setTransactionTypeFilter('');
        setMoneyTypeFilter('');
        setShowUncategorized(false);
        setCurrentPage(0);

        // Clear the data when clearing filters
        setTransactions([]);
        setSummaryData({
            totalIncome: 0,
            totalExpense: 0,
            totalCapital: 0,
            totalAdvance: 0,
            totalPayroll: 0,
            totalContra: 0,
            totalVatPayable: 0,
            totalWithdrawal: 0,
            totalBankGuaranteeReleased: 0,
            totalBankGuarantee: 0,
            totalBankGuaranteeCharged: 0,
            grandTotal: 0,
            filteredCount: 0,
            dateRange: 'All Dates'
        });
        setIsDataLoaded(false);
    };

    // MODIFIED handleFilterChange function
    const handleFilterChange = (filterType, value) => {
        if (!filterType || value === null || value === undefined) {
            return;
        }

        if (filterType === 'account') {
            setBankFilter(value || '');
        }
        if (filterType === 'type') {
            setTransactionTypeFilter(value || '');
        }

        setFilterDropdown(null);
        setApplyFilterClicked(true); // Set flag to trigger data load
    };


    const downloadVATReport = async (type = 'input') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            setLoading(true);

            // Updated endpoint based on your API route
            const endpoint = type === 'input' ? '/reports/vat-summary' : '/reports/vat/output';

            const response = await axios.get(`${backendUrl}/api/reports/vat-summary`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'blob',
            });
            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `vat_report_${new Date().toISOString().split('T')[0]}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up
            window.URL.revokeObjectURL(url);
            link.remove();

        } catch (error) {
            console.error("Error downloading report:", error);
            // Show error message to user
            alert('Failed to download report. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const fetchvatData = async (type, page = 1, perPage = 15, fromDate = null, toDate = null) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem('user-info'))?.token;
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(`${backendUrl}/api/reports/vat`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    per_page: perPage,
                    from_date: fromDate,
                    to_date: toDate,
                    type // Add type parameter to distinguish between input/output
                },
                skipLoader: true,
            });

            if (type === 'input') {
                setInVatData(Object.values(response.data.input_vat || []));
                setInputVatPagination({
                    currentPage: page - 1,
                    pageCount: Math.ceil(response.data.input_total / perPage) || 1,
                    totalItems: response.data.input_total
                });
            } else {
                setOuVatData(Object.values(response.data.output_vat || []));
                setOutputVatPagination({
                    currentPage: page - 1,
                    pageCount: Math.ceil(response.data.output_total / perPage) || 1,
                    totalItems: response.data.output_total
                });
            }
        } catch (error) {
            console.error('Error fetching VAT data:', error);
            // Reset to default pagination on error
            if (type === 'input') {
                setInputVatPagination(prev => ({ ...prev, pageCount: 1 }));
            } else {
                setOutputVatPagination(prev => ({ ...prev, pageCount: 1 }));
            }
        }
    };
    const fetchTaxDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/settings/tax`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const settings = response.data.setting;

            // ✅ Set the data
            setVatSettings(settings);
            const financialYear = new Date().getFullYear();
            const nextYear = financialYear + 1;

            const quarterMap = [
                {
                    key: 'q1',
                    label: `Q1 (${settings.q1_start_month} - ${settings.q1_end_month})`,
                    from: `${financialYear}-01-01`,
                    to: `${financialYear}-03-31`
                },
                {
                    key: 'q2',
                    label: `Q2 (${settings.q2_start_month} - ${settings.q2_end_month})`,
                    from: `${financialYear}-04-01`,
                    to: `${financialYear}-06-30`
                },
                {
                    key: 'q3',
                    label: `Q3 (${settings.q3_start_month} - ${settings.q3_end_month})`,
                    from: `${financialYear}-07-01`,
                    to: `${financialYear}-09-30`
                },
                {
                    key: 'q4',
                    label: `Q4 (${settings.q4_start_month} - ${settings.q4_end_month})`,
                    from: `${financialYear}-10-01`,
                    to: `${financialYear}-12-31`
                },
            ];

            setQuarterOptions(quarterMap);


        } catch (error) {
            console.error('Error fetching quotation terms:', error);
        }
    };

    useEffect(() => {
        if (activeTab === 'input-vat' || activeTab === 'output-vat') {
            if (Object.keys(vatSettings).length === 0) {
                fetchTaxDetails();
            }
        }
    }, [activeTab]);
    useEffect(() => {
        const handleTabShown = (e) => {
            const href = e.target.getAttribute('href'); // like '#input-vat'
            const tab = href?.replace('#', '');
            if (tab) setActiveTab(tab);
        };

        const tabLinks = document.querySelectorAll('[data-bs-toggle="tab"]');
        tabLinks.forEach(link => link.addEventListener('shown.bs.tab', handleTabShown));

        return () => {
            tabLinks.forEach(link => link.removeEventListener('shown.bs.tab', handleTabShown));
        };
    }, []);

    const fetchCategories = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const token = JSON.parse(localStorage.getItem('user-info'))?.token;
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(`${backendUrl}/api/categories?type=expense`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            setCategories(response.data.category);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    const fetchUsers = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/users`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });
            let usersData = [];
            if (Array.isArray(response.data.users)) {
                usersData = response.data.users;
            } else if (response.data.users && Array.isArray(response.data.users.data)) {
                usersData = response.data.users.data;
            } else if (response.data.users) {
                usersData = Object.values(response.data.users);
            }
            
            const sortedUsers = usersData.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setUsers(sortedUsers);        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const fetchBanks = async (accountType = '') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let url = `${backendUrl}/api/bank-accounts`;
            if (accountType) {
                url += `?type=${encodeURIComponent(accountType)}`; // Fetch specific type if provided
            }

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,
            });

            setBanks(response.data.account || response.data?.accounts || (Array.isArray(response.data?.data) ? response.data.data : [])); // ✅ Update state with all banks

        } catch (error) {
            console.error('Error fetching banks:', error);
        }
    };

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });
            const sortedClients = (response.data.Data || []).sort((a, b) => {
                const nameA = (a.name || a.company_name || a.first_name || '').toString().toLowerCase();
                const nameB = (b.name || b.company_name || b.first_name || '').toString().toLowerCase();
                return nameA.localeCompare(nameB);
            });
            setClients(sortedClients);
        } catch (error) {
            console.error('Error fetching clients:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch clients. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        }
    };
    const fetchVendors = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });
            const sortedVendors = (response.data.Data || []).sort((a, b) => {
                const nameA = (a.name || a.company_name || a.first_name || '').toString().toLowerCase();
                const nameB = (b.name || b.company_name || b.first_name || '').toString().toLowerCase();
                return nameA.localeCompare(nameB);
            });
            setVendors(sortedVendors);
        } catch (error) {
            console.error('Error fetching vendors:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch vendors. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        }
    };

    const fetchProjects = async (clientId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            if (!clientId) {
                setProjects([]); // ✅ Clear projects if no client selected
                return;
            }

            // Fetch ALL pages to ensure projects linked to invoices are included
            let allProjects = [];
            let currentPage = 1;
            let totalPages = 1;

            do {
                const response = await axios.get(`${backendUrl}/api/projects`, {
                    params: { client_id: clientId, all: true, page: currentPage, per_page: 100 },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    skipLoader: true,
                });

                const pageData = response.data.Data || response.data?.data || [];
                allProjects = allProjects.concat(pageData);

                // Check if there are more pages
                const pagination = response.data?.pagination;
                totalPages = pagination?.total_pages || 1;
                currentPage++;
            } while (currentPage <= totalPages);

            const sortedProjects = allProjects.sort((a, b) => {
                const nameA = (a.name || '').toString().toLowerCase();
                const nameB = (b.name || '').toString().toLowerCase();
                return nameA.localeCompare(nameB);
            });
            setProjects(sortedProjects);
        } catch (error) {
            console.error("Error fetching projects:", error);
            setProjects([]); // ✅ Ensure dropdown is cleared on error
        }
    };
    // Initial load remvoed to favor manual filter application



    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    //     const canEdit = permissions.includes('transaction-edit');
    //   const canDelete = permissions.includes('transaction-delete');
    const WithDeletePermission = withPermission(({ children }) => children, ['transactionaccount-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['transactionaccount-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['transactionaccount-create']);



    const addTransaction = async (newTransaction) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/transactions`, newTransaction, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const createdTransaction = response.data?.data;
            if (createdTransaction) {
                setTransactions((prevTransactions) => [...prevTransactions, createdTransaction]);
                setNewlyAddedId(createdTransaction.id);
                setIsDataLoaded(true); // Ensure list is shown even if no filters were applied
                
                // Clear the highlight after 10 seconds
                setTimeout(() => {
                    setNewlyAddedId(null);
                }, 10000);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal(); // Close modal after adding
        } catch (error) {
            if (error.response?.status === 403 && error.response?.data?.message) {
                const errorMessage = error.response.data.message;
                setAccountingLockMessage(errorMessage);

                Swal.fire({
                    icon: 'error',
                    title: 'Financial Year Locked',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });

                // Don't close modal if it's a lock error
                return { lockError: true };
            }
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error adding transaction:', error);
                return { genericError: error.message || 'An unexpected error occurred' };
            }
        }
    };


    const editTransaction = async (transactionId, updatedData) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let method = 'put';
            let url = `${backendUrl}/api/transactions/${transactionId}`;

            // Check if updatedData is FormData (for file uploads)
            if (updatedData instanceof FormData) {
                method = 'post';
                updatedData.append('_method', 'PUT'); // Tunnel PUT method for PHP
            }

            const response = await axios({
                method: method,
                url: url,
                data: updatedData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const updatedTransaction = response.data?.data;

            if (updatedTransaction) {
                setTransactions((prevTransactions) =>
                    prevTransactions.map((transaction) =>
                        transaction.id === updatedTransaction.id ? updatedTransaction : transaction
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.status === 403 && error.response?.data?.message) {
                const errorMessage = error.response.data.message;
                setAccountingLockMessage(errorMessage);

                Swal.fire({
                    icon: 'error',
                    title: 'Financial Year Locked',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });

                // Don't close modal if it's a lock error
                return { lockError: true };
            }
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating transaction:', error);
                return { genericError: error.message || 'An unexpected error occurred' };
            }
        }
    };
    const deleteTransaction = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // ✅ Get transaction from local state
                    const transaction = transactions.find(t => t.id === id);

                    // ✅ Delete from your app
                    await axios.delete(`${backendUrl}/api/transactions/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    // ✅ Update UI
                    setTransactions(transactions.filter(transaction => transaction.id !== id));

                    Swal.fire("Deleted!", "The transaction has been deleted.", "success");

                } catch (error) {
                    if (error.response?.status === 403 && error.response?.data?.message) {
                        const errorMessage = error.response.data.message;
                        setAccountingLockMessage(errorMessage);

                        Swal.fire({
                            icon: 'error',
                            title: 'Financial Year Locked',
                            text: errorMessage,
                            confirmButtonText: 'OK'
                        });

                        // Don't close modal if it's a lock error
                        return { lockError: true };
                    }
                    console.error('Error deleting transaction:', error);
                    Swal.fire("Error!", "Failed to delete transaction. Please try again.", "error");
                }
            }
        });
    };

    // const handleShowModal = (transactionId = null) => {

    //     if (transactionId) {
    //         const transactionToEdit = transactions.find(transaction => transaction.id === transactionId);
    //         if (transactionToEdit) {
    //             setSelectedTransactionData(transactionToEdit);
    //         }
    //     } else {
    //         setSelectedTransactionData(null);
    //     }
    //     setSelectedTransactionId(transactionId);
    //     setShowModal(true);
    // };
    const handleShowModal = (transactionId = null, mode = "view") => {
        if (transactionId !== null) {
            const transactionToEdit = transactions.find(transaction => transaction.id === transactionId);
            setSelectedTransactionData(transactionToEdit || null);
            setSelectedTransactionId(transactionId);
        } else {
            setSelectedTransactionData(null);
            setSelectedTransactionId(null);
            setErrors({});
        }

        // "edit" = editing existing, "create" = adding new (both allow form editing)
        // "view" = read-only view
        setIsEditMode(mode === "edit" || mode === "create");

        setShowModal(true);
    };

    // const handleFilterChange = (filterType, value) => {
    //     if (!filterType || value === null || value === undefined) {
    //         return; // Return early if filterType or value is invalid
    //     }

    //     if (filterType === 'account') {
    //         setBankFilter(value || ''); // Ensure the value is a valid string
    //     }
    //     if (filterType === 'type') {
    //         setTransactionTypeFilter(value || ''); // Ensure the value is a valid string
    //     }

    //     setFilterDropdown(null); // Close dropdown after selection
    // };

    useEffect(() => {
        fetchBanks();
        // fetchTransactions(1); // Removed to prevent loading all data on mount without filters
    }, []);
    const handleCloseModal = (savedTransaction = null) => {
        setShowModal(false);
        setSelectedTransactionId(null);
        setSelectedTransactionData(null);
        setErrors({});

        if (savedTransaction) {
            if (selectedTransactionId) {
                // Edit: replace the existing item in-place
                setTransactions((prev) =>
                    prev.map((tx) => (String(tx.id) === String(savedTransaction.id) ? savedTransaction : tx))
                );
            } else {
                // Create: prepend to the top of the list so it appears immediately
                setTransactions((prev) => [savedTransaction, ...prev]);
                setNewlyAddedId(savedTransaction.id);
                setIsDataLoaded(true);
                setTimeout(() => setNewlyAddedId(null), 10000);
            }
        }
    };

    const handlePageClick = (data) => {
        const page = data.selected + 1;
        setCurrentPage(data.selected);
        fetchTransactions(page);
    };
    const [inputVatPage, setInputVatPage] = useState(1);
    const [outputVatPage, setOutputVatPage] = useState(1);

    useEffect(() => {
        if (activeTab === 'input-vat') {
            setInputVatPage(1);
            fetchvatData('input', 1);
        } else if (activeTab === 'output-vat') {
            setOutputVatPage(1);
            fetchvatData('output', 1);
        }
    }, [activeTab]);

    const handleInputVatPageChange = (selectedPage) => {
        const newPage = selectedPage.selected + 1;
        setInputVatPage(newPage);
        fetchvatData('input', newPage);
    };

    const handleOutputVatPageChange = (selectedPage) => {
        const newPage = selectedPage.selected + 1;
        setOutputVatPage(newPage);
        fetchvatData('output', newPage);
    };
    // useEffect(() => {
    //     setInputVatPage(1); // Reset input VAT page to 1 when switching tabs
    //     fetchvatData(1); // Fetch data for input VAT page 1
    // }, [activeTab]); // activeTab should track whether you're on the Input VAT or Output VAT tab



    const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage + 1);  // The page is 0-indexed, so we add 1
        fetchvatData(selectedPage + 1);  // Pass the selected page to fetch data
    };
    // const applyDateFilter = () => {
    //     setDateFilterDropdown(false); // Close the dropdown after applying
    //     fetchTransactions();
    // };
    const applyDateFilterIn = () => {
        setDateFilterDropdown(false); // Close the dropdown after applying
        fetchvatData('input', 1, 15, startDateFilter, endDateFilter); // Fetch data with the new date range
    };
    const applyDateFilterOu = () => {
        setDateFilterDropdown(false); // Close the dropdown after applying
        fetchvatData('output', 1, 15, startDateFilter, endDateFilter); // Fetch data with the new date range
    };
    // const clearDateFilter = () => {
    //     setDateRange({ from: "", to: "" }); // Reset date inputs
    // };
    const handleTabChange = (tab) => {
        setSelectedTab(tab);
    };


    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${backendUrl}/api/transaction/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || ` Imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

            // Refresh the list after import
            setTimeout(() => window.location.reload(), 1000);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            if (error.response?.status === 403 && error.response?.data?.message) {
                Swal.fire({
                    icon: 'error',
                    title: 'Financial Year Locked',
                    text: error.response.data.message,
                    confirmButtonText: 'OK'
                });
                event.target.value = "";
                return;
            }
            console.error('Import error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            event.target.value = "";

        } finally {
        }
    };

    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/transaction/export`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob', // Important for file download
                }
            );

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `Transactions_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });

        } catch (error) {
            if (error.response?.status === 403 && error.response?.data?.message) {
                Swal.fire({
                    icon: 'error',
                    title: 'Financial Year Locked',
                    text: error.response.data.message,
                    confirmButtonText: 'OK'
                });
                return;
            }

            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
        }
    };
    const typeLabels = {
        income: "Income",
        expense: "Expense",
        capital: "Capital",
        advance: 'Advance',
        payroll: 'Payroll',
        contra: 'Contra',
        vat_payable: 'VAT Payment',
        withdrawal: 'Withdrawal',
        bank_guarantee_released: 'Bank Guarantee Released',
        bank_guarantee: 'Bank Guarantee',
        bad_debt_written_off: 'Bad Debt Written Off',
        vendor_bill_written_off: 'Accounts Payable Write-Off',
        bank_guarantee_charges: 'Bank Guarantee Charges',
        bank_service:'Bank Service Charges',
    };
    return (
        <div className="main-content">
            <style>
                {`
                    .newly-added-row {
                        border-left: 5px solid #2196f3 !important;
                    }
                    .newly-added-row td {
                        background-color: #e3f2fd !important;
                        color: #0d47a1 !important;
                        font-weight: 500;
                    }
                `}
            </style>
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Transactions</h4>

                            </div>
                        </div>
                    </div>
                    {/* Filter Section */}
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title mb-3">
                                        <FaFilter className="me-2" />
                                        Filters
                                    </h5>
                                    <div className="row g-2">
                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Date Range</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={dateRangeFilter}
                                                onChange={(e) => handleDateRangeChange(e.target.value)}
                                                style={{ fontSize: '11px', padding: '6px 12px' }}
                                            >
                                                <option value="yearly">Yearly</option>
                                                <option value="custom">Custom Range</option>
                                            </select>
                                        </div>

                                        {dateRangeFilter === 'yearly' && (
                                            <>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={startDateFilter ? dayjs(startDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    setSelectedYear(newValue);
                                                                    const dateStr = newValue.format('YYYY-MM-DD');
                                                                    // If year changed (or first time), snap to Jan 1st
                                                                    if (!startDateFilter || dayjs(startDateFilter).year() !== newValue.year()) {
                                                                        const start = newValue.startOf('year');
                                                                        setStartDateFilter(start.format('YYYY-MM-DD'));
                                                                        // Also auto-sync End Year
                                                                        setEndDateFilter(newValue.endOf('year').format('YYYY-MM-DD'));
                                                                        setSelectedEndYear(newValue);
                                                                    } else {
                                                                        setStartDateFilter(dateStr);
                                                                        if (endDateFilter && dayjs(dateStr).isAfter(dayjs(endDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                            setEndDateFilter(dayjs(dateStr).endOf('month').format('YYYY-MM-DD'));
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 12px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">End Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={endDateFilter ? dayjs(endDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    setSelectedEndYear(newValue);
                                                                    if (!endDateFilter || dayjs(endDateFilter).year() !== newValue.year()) {
                                                                        setEndDateFilter(newValue.endOf('year').format('YYYY-MM-DD'));
                                                                    } else {
                                                                        const dateStr = newValue.format('YYYY-MM-DD');
                                                                        if (startDateFilter && dayjs(dateStr).isBefore(dayjs(startDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                            setEndDateFilter(dayjs(startDateFilter).endOf('month').format('YYYY-MM-DD'));
                                                                        } else {
                                                                            setEndDateFilter(dateStr);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 12px' } }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </>
                                        )}

                                        {dateRangeFilter === 'custom' && (
                                            <>
                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">Start Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            openTo="year"
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={startDateFilter ? dayjs(startDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                const dateStr = newValue ? newValue.format("YYYY-MM-DD") : "";
                                                                setStartDateFilter(dateStr);
                                                                setSelectedYear(null);
                                                                if (newValue && endDateFilter && newValue.isAfter(dayjs(endDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                    setEndDateFilter(newValue.endOf('month').format('YYYY-MM-DD'));
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 12px' } }
                                                                },
                                                                actionBar: {
                                                                    actions: ['today', 'clear', 'cancel', 'accept'],
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>

                                                <div className="col-md-2">
                                                    <label className="form-label font-size-11 mb-1">End Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            openTo="year"
                                                            views={["year", "month", "day"]}
                                                            format="DD-MM-YYYY"
                                                            value={endDateFilter ? dayjs(endDateFilter) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue && startDateFilter && newValue.isBefore(dayjs(startDateFilter, "YYYY-MM-DD"), 'day')) {
                                                                    setEndDateFilter(dayjs(startDateFilter).endOf('month').format('YYYY-MM-DD'));
                                                                } else {
                                                                    setEndDateFilter(
                                                                        newValue ? newValue.format("YYYY-MM-DD") : ""
                                                                    );
                                                                }
                                                                setSelectedYear(null);
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: { style: { fontSize: '11px', padding: '6px 12px' } }
                                                                },
                                                                actionBar: {
                                                                    actions: ['today', 'clear', 'cancel', 'accept'],
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </>
                                        )}

                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 font-size-11">Account</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={bankFilter}
                                                onChange={(e) => setBankFilter(e.target.value)}
                                            >
                                                <option value="">All Accounts</option>
                                                {(Array.isArray(banks) ? banks : []).map((bank) => (
                                                    <option key={bank.id} value={bank.id}>
                                                        {bank.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Type</label>
                                            <select
                                                className="form-select font-size-11"
                                                value={transactionTypeFilter}
                                                onChange={(e) => setTransactionTypeFilter(e.target.value)}
                                            >
                                                <option value="">All Types</option>
                                                <option value="income">Income</option>
                                                <option value="expense">Expense</option>
                                                <option value="capital">Capital</option>
                                                <option value="advance">Advance</option>
                                                <option value="payroll">Payroll</option>
                                                <option value="contra">Contra</option>
                                                <option value="vat_payable">VAT Payment</option>
                                                <option value="withdrawal">Withdrawal</option>
                                                <option value="bank_guarantee_released">Bank Guarantee Released</option>
                                                <option value="bank_guarantee">Bank Guarantee</option>
                                                <option value="bad_debt_written_off">Bad Debt Write-off</option>
                                                <option value="vendor_bill_written_off">Accounts Payable Write-Off</option>
                                                <option value="bank_guarantee_charges">Bank Guarantee Charges</option>
                                                <option value="petty_cash">Petty Cash</option>
                                                <option value="bank_service">Bank Service Charges</option>

                                            </select>
                                        </div>

                                        <div className="col-md-2">
                                            <label className="form-label font-size-11 mb-1">Cash IN/OUT</label>
                                            <select
                                                className="form-select font-size-11 text-uppercase fw-bold"
                                                value={moneyTypeFilter}
                                                onChange={(e) => setMoneyTypeFilter(e.target.value)}
                                                style={{ color: moneyTypeFilter === 'in' ? '#198754' : (moneyTypeFilter === 'out' ? '#dc3545' : 'inherit') }}
                                            >
                                                <option value="">Select</option>
                                                <option value="in" style={{ color: '#198754' }}>Cash In (Debit)</option>
                                                <option value="out" style={{ color: '#dc3545' }}>Cash Out (Credit)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row g-2 mt-2">
                                        <div className="col-md-9">
                                            <InputGroup size="sm">
                                                <InputGroup.Text className="bg-light border-end-0">
                                                    <FiSearch />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    className="bg-light border-start-0 ps-0"
                                                    placeholder="Search narration, amount, date, or linked items (invoice/expense)..."
                                                    value={searchQuery}
                                                    onChange={handleSearchChange}
                                                />
                                            </InputGroup>
                                        </div>
                                        <div className="col-md-3 d-flex align-items-end gap-1">
                                            <button
                                                className="btn btn-primary btn-sm font-size-11"
                                                style={{ width: '80px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                onClick={applyFilters}
                                            >
                                                Apply
                                            </button>
                                            <button
                                                className="btn btn-secondary btn-sm font-size-11"
                                                style={{ width: '80px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                onClick={clearAllFilters}
                                            >
                                                Clear
                                            </button>
                                            {!showSummaryBox && isDataLoaded && (
                                                <button
                                                    className="btn btn-outline-info btn-sm font-size-11 py-1"
                                                    onClick={() => setShowSummaryBox(true)}
                                                >
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Active Filters Display */}
                                    {(startDateFilter || endDateFilter || bankFilter || transactionTypeFilter || searchQuery) && (
                                        <div className="mt-2">
                                            <small className="text-muted">Active Filters:</small>
                                            <div className="d-flex flex-wrap gap-1 mt-1">
                                                {startDateFilter && endDateFilter && dayjs(startDateFilter).isSame(dayjs(endDateFilter).startOf('year'), 'day') && dayjs(endDateFilter).isSame(dayjs(startDateFilter).endOf('year'), 'day') ? (
                                                    <span className="badge bg-info">
                                                        Period: {dayjs(startDateFilter).format('MMM YYYY')} – {dayjs(endDateFilter).format('MMM YYYY')}
                                                    </span>
                                                ) : (
                                                    <>
                                                        {startDateFilter && (
                                                            <span className="badge bg-info">
                                                                From: {dayjs(startDateFilter).format('DD-MM-YYYY')}
                                                            </span>
                                                        )}
                                                        {endDateFilter && (
                                                            <span className="badge bg-info">
                                                                To: {dayjs(endDateFilter).format('DD-MM-YYYY')}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                                {bankFilter && (
                                                    <span className="badge bg-warning text-dark">
                                                        Account: {banks.find(b => b.id == bankFilter)?.name}
                                                    </span>
                                                )}
                                                {transactionTypeFilter && (
                                                    <span className="badge bg-success">
                                                        Type: {typeLabels[transactionTypeFilter] || transactionTypeFilter}
                                                    </span>
                                                )}
                                                {searchQuery && (
                                                    <span className="badge bg-primary">
                                                        Search: "{searchQuery}"
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary Box */}
                    {showSummaryBox && isDataLoaded && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="card-title mb-0">Transaction Summary</h5>
                                            <div>
                                                <span className="badge bg-info me-2">
                                                    Total: {summaryData?.filteredCount ?? 0} transactions
                                                </span>
                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => setShowSummaryBox(false)}
                                                >
                                                    Hide
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row g-2 row-cols-2 row-cols-md-3 row-cols-lg-5">
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#f0fdf4' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Income</small>
                                                        <h6 className="mb-0 text-success font-size-13 fw-bold">
                                                            {Number(summaryData.totalIncome).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#fef2f2' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Expense</small>
                                                        <h6 className="mb-0 text-danger font-size-13 fw-bold">
                                                            {Number(summaryData.totalExpense).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#eff6ff' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Capital</small>
                                                        <h6 className="mb-0 text-info font-size-13 fw-bold">
                                                            {Number(summaryData.totalCapital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#fffbeb' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Advance</small>
                                                        <h6 className="mb-0 text-warning font-size-13 fw-bold">
                                                            {Number(summaryData.totalAdvance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#f8fafc' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Payroll</small>
                                                        <h6 className="mb-0 text-secondary font-size-13 fw-bold">
                                                            {Number(summaryData.totalPayroll).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#f5f3ff' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Contra</small>
                                                        <h6 className="mb-0 text-primary font-size-13 fw-bold">
                                                            {Number(summaryData.totalContra).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#faf5ff' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">VAT Pay</small>
                                                        <h6 className="mb-0 text-purple font-size-13 fw-bold">
                                                            {Number(summaryData.totalVatPayable).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow-sm border h-100 mb-0" style={{ backgroundColor: '#fff1f2' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Withdraw</small>
                                                        <h6 className="mb-0 text-danger font-size-13 fw-bold">
                                                            {Number(summaryData.totalWithdrawal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card shadow border h-100 mb-0 text-white" style={{ backgroundColor: '#fff1f2' }}>
                                                    <div className="card-body p-2 text-center">
                                                        <small className="text-muted d-block font-size-10 text-uppercase fw-bold">Net Total</small>
                                                        <h6 className="mb-0 font-size-13 text-muted fw-bold">
                                                            {Number(summaryData.grandTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    {/* Transaction Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="tab-content">
                                        {/* Transactions Tab */}
                                        <div className={`tab-pane ${activeTab === 'transactions' ? 'show active' : ''}`} id="transactions" role="tabpanel">
                                            <div className="d-flex justify-content-end mb-3">

                                                <div className="d-flex align-items-center gap-2">
                                                    {/* Filter Icon Only */}
                                                    <div className="dropdown icon-button">
                                                        <button
                                                            className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"
                                                            type="button"
                                                            id="transactionFilter"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-filter-alt icon-style"></i>
                                                        </button>

                                                        <ul className="dropdown-menu" aria-labelledby="transactionFilter">
                                                            <li>
                                                                <button className="dropdown-item" onClick={() => {
                                                                    setShowUncategorized(false);
                                                                    applyFilters();
                                                                }}>
                                                                    All Transactions
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button className="dropdown-item" onClick={() => {
                                                                    setShowUncategorized(true);
                                                                    applyFilters();
                                                                }}>
                                                                    Unrecognised Clients
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        {/* Export Button */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-light border"
                                                            onClick={handleExport}
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="Export"
                                                        >
                                                            <i className="mdi mdi-file-excel text-success"></i>
                                                        </button>

                                                        {/* Import Button */}
                                                        <input
                                                            type="file"
                                                            accept=".xlsx, .xls"
                                                            id="importLeadsFile"
                                                            onChange={handleImport}
                                                            style={{ display: "none" }}
                                                        />
                                                        <label
                                                            htmlFor="importLeadsFile"
                                                            className="btn btn-light border mb-0"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="Import"
                                                        >
                                                            <i className="mdi mdi-upload text-primary"></i>
                                                        </label>
                                                        {/* Add Transaction Button (rounded) */}
                                                        <WithCreatePermission>
                                                            <button
                                                                type="button"
                                                                className=" btn rounded-circle d-flex align-items-center justify-content-center icon-rounded"
                                                                onClick={() => handleShowModal(null, "create")}
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="top"
                                                                title="Add Transaction"
                                                            >
                                                                <i className="mdi mdi-plus"></i>
                                                            </button>
                                                        </WithCreatePermission>


                                                    </div>
                                                </div>


                                            </div>

                                            <div>
                                                <table className="table align-middle table-nowrap table-check table-list">

                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th style={{ width: '20px' }} className="align-middle">
                                                                <div className="form-check font-size-16">
                                                                    <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                    <label className="form-check-label" htmlFor="checkAll"></label>
                                                                </div>
                                                            </th>

                                                            <th style={{ width: '50px' }} className="align-middle text-center">#</th>
                                                            <th style={{ width: '25%' }} className="align-middle">Transaction</th>
                                                            <th style={{ width: '110px' }} className="align-middle">Date</th>
                                                            <th style={{ width: '120px' }} className="align-middle">Type</th>
                                                            <th style={{ width: '150px' }} className="align-middle text-start ">Reference</th>
                                                            <th style={{ width: '150px' }} className="align-middle">Account</th>
                                                            <th style={{ width: '150px' }} className="align-middle text-end">Amount</th>
                                                            <th style={{ width: '150px' }} className="align-middle text-end">
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip id="balance-tooltip">Running Balance (Ledger Total per Account)</Tooltip>}
                                                                >
                                                                    <span>
                                                                        Running Balance
                                                                        {bankFilter && (banks.find(b => String(b.id) === String(bankFilter))?.currency === 'USD' || banks.find(b => String(b.id) === String(bankFilter))?.base_currency?.currency === 'USD') ? ' (USD)' : ''}
                                                                    </span>

                                                                </OverlayTrigger>
                                                            </th>
                                                            <th style={{ width: '80px' }} className="align-middle text-end">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transactionsWithBalances.length > 0 ? (
                                                            transactionsWithBalances.map((transaction, index) => (
                                                                <tr 
                                                                    key={transaction.id}
                                                                    className={String(newlyAddedId) === String(transaction.id) ? 'newly-added-row' : ''}
                                                                >
                                                                    <td>
                                                                        <div className="form-check font-size-16">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`transactionCheck${index}`}
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor={`transactionCheck${index}`}
                                                                            ></label>
                                                                        </div>
                                                                    </td>
                                                                    <td>{index + 1}</td>
                                                                    <td onClick={() => handleShowModal(transaction.id, "view")} className='text-start narration-cell' title={transaction.description || ''}>
                                                                        {transaction.description}
                                                                    </td>
                                                                    <td onClick={() => handleShowModal(transaction.id, "view")}>
                                                                        {transaction.date
                                                                            ? new Date(transaction.date).toLocaleDateString('en-GB').replace(/\//g, '-')
                                                                            : ''}
                                                                    </td>
                                                                    <td onClick={() => handleShowModal(transaction.id, "view")}>
                                                                        {transaction.type === 'advance' ? (
                                                                            transaction.advance_type === 'vendor' ? 'Vendor Advance' :
                                                                                transaction.advance_type === 'client' ? 'Customer Advance' :
                                                                                    ['pettycash', 'user', 'petty_cash'].includes(transaction.advance_type) ? 'Petty Cash Advance' :
                                                                                        'Advance'
                                                                        ) : (typeLabels[transaction.type] ?? transaction.type)}
                                                                    </td>
                                                                    <td onClick={() => handleShowModal(transaction.id, "view")} className="text-start">
                                                                        {transaction.reference_no || '-'}
                                                                    </td>
                                                                    <td>{transaction.account?.name}</td>

                                                                    <td className="text-end">
                                                                        <div className="d-flex align-items-center justify-content-end">

                                                                            {/* UP arrow (money coming in) */}
                                                                            {(
                                                                                ['income', 'receipt', 'capital', 'bank_guarantee_released'].includes(transaction.type) ||
                                                                                (transaction.type === 'advance' && transaction.advance_type === 'client')
                                                                            ) && (
                                                                                    <FiArrowUp className="text-success me-1" />
                                                                                )}

                                                                            {/* DOWN arrow (money going out) */}
                                                                            {(
                                                                                ['expense', 'payment', 'withdrawal', 'payroll', 'vat_payable', 'bank_guarantee', 'bank_guarantee_charges', 'bad_debt_written_off'].includes(transaction.type) ||
                                                                                (transaction.type === 'advance' && transaction.advance_type === 'vendor')
                                                                            ) && (
                                                                                    <FiArrowDown className="text-danger me-1" />
                                                                                )}

                                                                            {/* Contra */}
                                                                            {transaction.type === 'contra' && (
                                                                                <i
                                                                                    className="mdi mdi-swap-horizontal text-primary me-1"
                                                                                    style={{ fontSize: '14px' }}
                                                                                />
                                                                            )}

                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={
                                                                                    <Tooltip id={`tooltip-amount-${transaction.id}`} className="transaction-tooltip">
                                                                                        <div className="text-start p-1" style={{ minWidth: '180px' }}>
                                                                                            {/* 1. BANK CHARGES & VAT (Bank Guarantee & Standard) */}
                                                                                            {(Number(transaction.bank_service_charge || 0) > 0 || 
                                                                                              Number(transaction.bank_vat_amount || 0) > 0 ||
                                                                                              Number(transaction.commission_fee || 0) > 0 ||
                                                                                              Number(transaction.commission_vat || 0) > 0 ||
                                                                                              [
                                                                                                'income', 'expense', 'capital', 'advance', 'payroll', 
                                                                                                'contra', 'vat_payable', 'withdrawal', 'receipt', 'payment',
                                                                                                'bank_guarantee', 'bank_guarantee_charges', 'bank_guarantee_released', 'bad_debt_written_off'
                                                                                              ].includes(transaction.type)) && (
                                                                                                <div className="mb-2 border-bottom border-secondary pb-1">
                                                                                                    <div className="font-size-11 text-uppercase fw-bold text-info border-bottom mb-1 pb-1">Transaction Breakdown</div>
                                                                                                    <div className="d-flex justify-content-between">
                                                                                                        <span>Transaction Amount:</span>
                                                                                                        <span className="fw-bold">{formatTooltipCurrency(transaction.amount, transaction)}</span>
                                                                                                    </div>
                                                                                                    
                                                                                                    {/* Bank Guarantee Specifics */}
                                                                                                    {(Number(transaction.commission_fee || 0) > 0 || Number(transaction.commission_vat || 0) > 0) && (
                                                                                                        <div className="mt-1 border-top border-soft-secondary pt-1">
                                                                                                            {Number(transaction.commission_fee || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>Commission:</span>
                                                                                                                    <span className="text-info fw-bold">+{formatTooltipCurrency(transaction.commission_fee, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                            {Number(transaction.commission_vat || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>Comm. VAT:</span>
                                                                                                                    <span className="text-info">+{formatTooltipCurrency(transaction.commission_vat, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                      {(Number(transaction.wps_charge || 0) > 0 || Number(transaction.wps_vat || 0) > 0) && (
                                                                                                        <div className="mt-1 border-top border-soft-secondary pt-1">
                                                                                                            {Number(transaction.wps_charge || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>WPS Charge:</span>
                                                                                                                    <span className="text-info fw-bold">+{formatTooltipCurrency(transaction.wps_charge, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                            {Number(transaction.wps_vat || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>WPS VAT:</span>
                                                                                                                    <span className="text-info">+{formatTooltipCurrency(transaction.wps_vat, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}

                                                                                                    {/* Standard Bank Charges */}
                                                                                                    {(Number(transaction.bank_service_charge || 0) > 0 || Number(transaction.bank_vat_amount || 0) > 0 || Number(transaction.other_bank_service_charge || 0) > 0) && (
                                                                                                        <div className="mt-1 border-top border-soft-secondary pt-1">
                                                                                                            {Number(transaction.bank_service_charge || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>Bank Service Charge:</span>
                                                                                                                    <span className="text-info fw-bold">{getTooltipSign(transaction)}{formatTooltipCurrency(transaction.bank_service_charge, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                            {Number(transaction.other_bank_service_charge || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>Other Bank Charge:</span>
                                                                                                                    <span className="text-info fw-bold">{getTooltipSign(transaction)}{formatTooltipCurrency(transaction.other_bank_service_charge, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                            {Number(transaction.bank_vat_amount || 0) > 0 && (
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span>Bank Charge VAT:</span>
                                                                                                                    <span className="text-info">{getTooltipSign(transaction)}{formatTooltipCurrency(transaction.bank_vat_amount, transaction)}</span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                    {/* Total Application summary */}
                                                                                                    <div className="mt-2 border-top border-info pt-1 d-flex justify-content-between fw-bold font-size-11 text-info">
                                                                                                        <span>{['income', 'receipt', 'capital', 'bank_guarantee_released'].includes(transaction.type) || (transaction.type === 'advance' && transaction.advance_type === 'client') ? 'Net Received:' : 'Total Paid:'}</span>
                                                                                                        <span>{formatCurrency(getTooltipNetTotal(transaction), transaction)}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* 2. ADVANCE APPLICATION BREAKDOWN */}
                                                                                            {Number(transaction.applied_advance || 0) > 0 && (
                                                                                                <div className="mb-2 border-bottom border-secondary pb-1">
                                                                                                    <div className="font-size-11 text-uppercase fw-bold text-warning border-bottom mb-1 pb-1">Advance Applied</div>
                                                                                                    <div className="d-flex justify-content-between font-size-11">
                                                                                                        <span>Total Settlement:</span>
                                                                                                        <span className="fw-bold">{formatCurrency(Number(transaction.amount || 0) + Number(transaction.applied_advance || 0), transaction)}</span>
                                                                                                    </div>
                                                                                                    <div className="d-flex justify-content-between font-size-11 text-warning-soft mt-1">
                                                                                                        <span>
                                                                                                            <i className="bx bx-right-arrow-alt me-1"></i>
                                                                                                            Applied Advance:
                                                                                                        </span>
                                                                                                        <span className="fw-bold">-{formatCurrency(transaction.applied_advance, transaction)}</span>
                                                                                                    </div>
                                                                                                    <div className="d-flex justify-content-between font-size-11 text-info-soft border-top border-soft-secondary mt-1 pt-1 opacity-75">
                                                                                                        <span>Net Cash Flow:</span>
                                                                                                        <span className="fw-bold">{formatCurrency(transaction.amount, transaction)}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* 3. EXPENSE BILLS BREAKDOWN */}
                                                                                            {transaction.transaction_expense_items && transaction.transaction_expense_items.length > 0 && (
                                                                                                <div className="mb-1">
                                                                                                    <div className="font-size-11 text-uppercase fw-bold text-danger border-bottom mb-1 pb-1">Applied Bills</div>
                                                                                                    {/* Individual Items */}
                                                                                                        {transaction.transaction_expense_items.map((item, idx) => {
                                                                                                            const billCurrency = item.expense?.vendor_currency || 'AED';
                                                                                                            const transCurrency = transaction.currency?.currency || 'AED';
                                                                                                            const billTotal = Number(item.expense?.total_amount || item.expense?.amount || 0);
                                                                                                            const paidInThisTransRaw = Number(item.paid_amount || 0);
                                                                                                            
                                                                                                            // Multi-currency correction:
                                                                                                            // If bill is USD and transaction is AED, we must convert paid amount to USD for balance subtraction
                                                                                                            let paidInBillCurrency = paidInThisTransRaw;
                                                                                                            const billExchangeRate = Number(item.expense?.exchange_rate || 3.692);
                                                                                                            
                                                                                                            if (billCurrency !== transCurrency) {
                                                                                                                if (billCurrency === 'USD' && transCurrency === 'AED') {
                                                                                                                    paidInBillCurrency = paidInThisTransRaw / billExchangeRate;
                                                                                                                } else if (billCurrency === 'AED' && transCurrency === 'USD') {
                                                                                                                    paidInBillCurrency = paidInThisTransRaw * billExchangeRate;
                                                                                                                }
                                                                                                            }

                                                                                                            const totalPaidOnBill = Number(item.expense?.paid_amount || 0);

                                                                                                            // If totalPaidOnBill is 0 or doesn't include the current payment, subtract current payment manually
                                                                                                            // Note: We want the balance AFTER this transaction
                                                                                                            let currentPaidSoFar = totalPaidOnBill;
                                                                                                            if (currentPaidSoFar < paidInBillCurrency) {
                                                                                                                currentPaidSoFar = paidInBillCurrency;
                                                                                                            }

                                                                                                            const remaining = billTotal - paidInThisTransRaw;
                                                                                                            
                                                                                                            return (
                                                                                                                <div key={idx} className="mb-2 last-child-mb-0 border-soft-bottom pb-1">
                                                                                                                    <div className="d-flex justify-content-between font-size-11">
                                                                                                                        <span>{item.expense?.invoice_no || 'Expense'}</span>
                                                                                                                        <span className="text-muted">Total: {formatCurrency(billTotal, transaction)}</span>
                                                                                                                    </div>
                                                                                                                    <div className="d-flex justify-content-between font-size-11">
                                                                                                                        <span className="text-danger">Paid:</span>
                                                                                                                        <span className="text-danger">
                                                                                                                            {transCurrency !== billCurrency ? (
                                                                                                                                <span className="me-1">{formatCurrency(paidInThisTransRaw, transaction)}</span>
                                                                                                                            ) : null}
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                    {remaining > 0 && (
                                                                                                                        <div className="d-flex justify-content-between font-size-10 text-warning-soft italic">
                                                                                                                            <span>Bal:{formatCurrency(remaining, transaction)}</span>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            );
                                                                                                        })}

                                                                                                    {/* Aggregated Summary for Multiple Items */}
                                                                                                    {transaction.transaction_expense_items.length > 1 && (
                                                                                                        <div className="mt-2 pt-1 border-top border-danger border-2">
                                                                                                            <div className="d-flex justify-content-between font-size-11 fw-bold">
                                                                                                                <span>Combined Total:</span>
                                                                                                                <span>{formatCurrency(transaction.transaction_expense_items.reduce((s, i) => s + Number(i.expense?.total_amount || 0), 0), transaction)}</span>
                                                                                                            </div>
                                                                                                            <div className="d-flex justify-content-between font-size-11 fw-bold text-danger">
                                                                                                                <span>Total Paid:</span>
                                                                                                                <span>-{formatCurrency(transaction.transaction_expense_items.reduce((s, i) => s + Number(i.paid_amount || 0), 0), transaction)}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}

                                                                                            {/* 4. INCOME INVOICES BREAKDOWN */}
                                                                                            {transaction.transaction_invoice_items && transaction.transaction_invoice_items.length > 0 && (
                                                                                                <div className="mb-1">
                                                                                                    <div className="font-size-11 text-uppercase fw-bold text-success border-bottom mb-1 pb-1">Applied Invoices</div>
                                                                                                    
                                                                                                    {/* Individual Items */}
                                                                                                    {transaction.transaction_invoice_items.map((item, idx) => {
                                                                                                        const invTotal = Number(item.invoice?.total_amount || item.invoice?.amount || 0);
                                                                                                        const recInThis = Number(item.paid_amount || 0);
                                                                                                        const remaining = invTotal - Number(item.invoice?.paid_amount || 0);
                                                                                                        
                                                                                                        return (
                                                                                                            <div key={idx} className="mb-2 last-child-mb-0 border-soft-bottom pb-1">
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span className="text-truncate" style={{ maxWidth: '120px' }}>
                                                                                                                        {item.invoice?.invoice_no || item.invoice?.id || 'Invoice'}
                                                                                                                    </span>
                                                                                                                    <span className="text-muted">Total: {formatCurrency(invTotal, transaction)}</span>
                                                                                                                </div>
                                                                                                                <div className="d-flex justify-content-between font-size-11">
                                                                                                                    <span className="text-success">Received:</span>
                                                                                                                    <span className="text-success">+{formatCurrency(recInThis, transaction)}</span>
                                                                                                                </div>
                                                                                                                {remaining > 0 && (
                                                                                                                    <div className="d-flex justify-content-between font-size-10 text-warning-soft italic">
                                                                                                                        <span>Bal: {formatCurrency(remaining, transaction)}</span>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        );
                                                                                                    })}

                                                                                                    {/* Aggregated Summary for Multiple Items */}
                                                                                                    {transaction.transaction_invoice_items.length > 1 && (
                                                                                                        <div className="mt-2 pt-1 border-top border-success border-2">
                                                                                                            <div className="d-flex justify-content-between font-size-11 fw-bold">
                                                                                                                <span>Combined Total:</span>
                                                                                                                <span>{formatCurrency(transaction.transaction_invoice_items.reduce((s, i) => s + Number(i.invoice?.total_amount || 0), 0), transaction)}</span>
                                                                                                            </div>
                                                                                                            <div className="d-flex justify-content-between font-size-11 fw-bold text-success">
                                                                                                                <span>Total Received:</span>
                                                                                                                <span>+{formatCurrency(transaction.transaction_invoice_items.reduce((s, i) => s + Number(i.paid_amount || 0), 0), transaction)}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}

                                                                                            {/* 5. DEDUCTIONS & CHARGES */}
                                                                                            {(Number(transaction.deduction_amount || 0) > 0 || Number(transaction.other_bank_service_charge || 0) > 0 || Number(transaction.bank_service_charge || 0) > 0 || Number(transaction.bank_vat_amount || 0) > 0 || Number(transaction.wps_charge || 0) > 0 || Number(transaction.wps_vat || 0) > 0) && (
                                                                                                <div className="mt-2 border-top border-secondary pt-1">
                                                                                                    <div className="font-size-10 text-muted">
                                                                                                        {transaction.type === 'payroll' ? 'Payroll Fees & Charges:' : 'Deduction & Charge Details:'}
                                                                                                    </div>
                                                                                                    <div className="font-size-11">
                                                                                                        {Number(transaction.wps_charge || 0) > 0 && (
                                                                                                            <div className="d-flex justify-content-between">
                                                                                                                <span>WPS Charge:</span>
                                                                                                                <span>{transaction.type === 'payroll' ? '+' : '-'}{formatCurrency(transaction.wps_charge, transaction)}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {Number(transaction.wps_vat || 0) > 0 && (
                                                                                                            <div className="d-flex justify-content-between">
                                                                                                                <span>WPS VAT:</span>
                                                                                                                <span>{transaction.type === 'payroll' ? '+' : '-'}{formatCurrency(transaction.wps_vat, transaction)}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {Number(transaction.deduction_amount || 0) > 0 && (
                                                                                                            <div className="d-flex justify-content-between">
                                                                                                                <span>Service Deduction:</span>
                                                                                                                <span>-{formatCurrency(transaction.deduction_amount, transaction)}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {Number(transaction.other_bank_service_charge || 0) > 0 && (
                                                                                                            <div className="d-flex justify-content-between">
                                                                                                                <span>Other Bank Charge:</span>
                                                                                                                <span>-{formatCurrency(transaction.other_bank_service_charge, transaction)}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {Number(transaction.bank_service_charge || 0) > 0 && (
                                                                                                            <div className="d-flex justify-content-between">
                                                                                                                <span>Bank Service Charge:</span>
                                                                                                                <span>-{formatCurrency(transaction.bank_service_charge, transaction)}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {Number(transaction.bank_vat_amount || 0) > 0 && (
                                                                                                            <div className="d-flex justify-content-between">
                                                                                                                <span>Bank Charge VAT:</span>
                                                                                                                <span>-{formatCurrency(transaction.bank_vat_amount, transaction)}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                        {transaction.type !== 'payroll' && (
                                                                                                            <div className="d-flex justify-content-between border-top border-soft-secondary mt-1 fw-bold">
                                                                                                                <span>Total Adj.:</span>
                                                                                                                <span className="text-danger">-{formatCurrency(
                                                                                                                    Number(transaction.deduction_amount || 0) + 
                                                                                                                    Number(transaction.other_bank_service_charge || 0) + 
                                                                                                                    Number(transaction.bank_service_charge || 0) + 
                                                                                                                    Number(transaction.bank_vat_amount || 0),
                                                                                                                    transaction
                                                                                                                )}</span>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {!transaction.bank_service_charge && 
                                                                                             !transaction.transaction_expense_items && 
                                                                                             !transaction.transaction_invoice_items && 
                                                                                             !transaction.applied_advance &&
                                                                                             !transaction.commission_fee &&
                                                                                                !transaction.commission_vat &&
                                                                                                !transaction.wps_charge &&
                                                                                             transaction.type !== 'advance' && (
                                                                                                <span>Amount: {formatCurrency(transaction.amount)}</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <span className="fw-bold cursor-pointer underline-on-hover">
                                                                                    {Number(transaction.amount || 0).toLocaleString('en-US', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </span>
                                                                            </OverlayTrigger>

                                                                                <span className="text-muted ms-1 font-size-11">
                                                                                (
                                                                                {transaction.transaction_currency_code ||
                                                                                    transaction.currency?.currency ||
                                                                                    (transaction.transaction_expense_items &&
                                                                                        transaction.transaction_expense_items.length > 0 &&
                                                                                        transaction.transaction_expense_items[0]?.expense?.vendor_currency) ||
                                                                                    'AED'}
                                                                                )
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    
                                                                    <td className="text-end align-middle">
                                                                        <span className="fw-bold">
                                                                            {(() => {
                                                                                const displayedRunningBalance = getDisplayedRunningBalance(transaction, index, transactionsWithBalances);
                                                                                if (displayedRunningBalance === null) return '-';

                                                                                const bankId = transaction.account_id || transaction.from_bank_id || transaction.to_bank_id;
                                                                                const bank = banks.find(b => String(b.id) === String(bankId));
                                                                                // base_currency_id 178 = USD, 231 = AED
                                                                                // Check bank's base_currency_id OR look up by account_id from banks array
                                                                                const USD_CURRENCY_ID = 178;
                                                                                const isUSDBank = bank ? 
                                                                                    (Number(bank.base_currency_id) === USD_CURRENCY_ID || bank?.base_currency?.currency === 'USD' || bank?.currency === 'USD')
                                                                                    : false;

                                                                                let balance = displayedRunningBalance;
                                                                                let currencyLabel = 'AED';
                                                                                if (isUSDBank) {
                                                                                    balance = balance / 3.653; // USD Conversion
                                                                                    currencyLabel = 'USD';
                                                                                 }

                                                                                return (
                                                                                    <>
                                                                                        <span>
                                                                                            {balance.toLocaleString('en-US', {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2
                                                                                            })}
                                                                                        </span>
                                                                                        <span className="text-muted ms-1 font-size-11">
                                                                                            ({currencyLabel})
                                                                                        </span>
                                                                                    </>
                                                                                );
                                                                            })()}


                                                                        </span>
                                                                    </td>


                                                                    {/* <td>{transaction.category?.name||transaction.project?.name}</td> */}
                                                                    <td>
                                                                        {/* Action buttons for Edit and Delete */}
                                                                        <div className="dropdown">
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                style={{ cursor: 'pointer' }}
                                                                            ></i>
                                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleShowModal(transaction.id, "view")}
                                                                                    >
                                                                                        View Details
                                                                                    </button>
                                                                                </li>
                                                                                {isDateInLockedPeriod(transaction.date) ? (
                                                                                    <li className="px-3 py-1 text-muted small d-flex align-items-center">
                                                                                        <i className="mdi mdi-lock me-1"></i> Locked Period
                                                                                    </li>
                                                                                ) : (
                                                                                    <>
                                                                                        {/* {canEdit && ( */}
                                                                                        <WithEditPermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleShowModal(transaction.id, "edit")}
                                                                                            >
                                                                                                Edit
                                                                                            </button>
                                                                                        </WithEditPermission>
                                                                                        {/* )} */}

                                                                                        {/* {canDelete && ( */}
                                                                                        <WithDeletePermission>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => deleteTransaction(transaction.id)}
                                                                                            >
                                                                                                Delete
                                                                                            </button>
                                                                                        </WithDeletePermission>
                                                                                    </>
                                                                                )}
                                                                                {/* )} */}
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9">No transactions found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {/* <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {transactions.length} entries</span> */}
                                                <div className="d-flex justify-content-end pagination-sm">
                                                    {pageCount > 0 && (
                                                        <ReactPaginate
                                                        previousLabel={'<'}
                                                        nextLabel={'>'}
                                                        breakLabel={'...'}
                                                        pageCount={pageCount}
                                                        marginPagesDisplayed={2}
                                                        pageRangeDisplayed={3}
                                                        onPageChange={handlePageClick}
                                                        containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                        pageClassName={'page-item'}
                                                        pageLinkClassName={'page-link'}
                                                        previousClassName={'page-item previous'}
                                                        previousLinkClassName={'page-link'}
                                                        nextClassName={'page-item next'}
                                                        nextLinkClassName={'page-link'}
                                                        breakClassName={'page-item'}
                                                        breakLinkClassName={'page-link'}
                                                        activeClassName={'active'}
                                                        forcePage={currentPage} // Add this line - uses 0-based index
                                                        />
                                                    )}
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                        <div className={`tab-pane ${activeTab === 'input-vat' ? 'show active' : ''}`} id="input-vat" role="tabpanel">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div className="d-flex">
                                                    <div className="search-box me-2 mb-2 d-inline-block">

                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center gap-2">

                                                    <div className="dropdown icon-button">
                                                        <button
                                                            className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"
                                                            type="button"
                                                            id="quarterFilter"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-calendar icon-style" title="Filter by Quarter"></i>
                                                        </button>
                                                        <ul className="dropdown-menu" aria-labelledby="quarterFilter">
                                                            {quarterOptions.map((q, index) => (
                                                                <li key={index}>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => {
                                                                            setSelectedQuarterLabel(q.label);
                                                                            setStartDateFilter(q.from);
                                                                            setEndDateFilter(q.to);
                                                                            fetchvatData('input', 1, 15, q.from, q.to);
                                                                        }}
                                                                    >
                                                                        {q.label}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"
                                                        onClick={() => downloadVATReport()}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Generate Report"
                                                        disabled={loading}
                                                    >
                                                        <FiDownload size={18} className="text-primary" />
                                                    </button>




                                                </div>


                                            </div>
                                            <div>
                                                <table className="table align-middle table-nowrap table-check table-list">

                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th style={{ width: '20px' }} className="align-middle">
                                                                <div className="form-check font-size-16">
                                                                    <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                    <label className="form-check-label" htmlFor="checkAll"></label>
                                                                </div>
                                                            </th>
                                                            <th className="align-middle">#</th>
                                                            <th className="align-middle">
                                                                Date
                                                                <div className="dropdown d-inline-block">
                                                                    <FaFilter
                                                                        className="ms-2 cursor-pointer filter-color"
                                                                        onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
                                                                    />
                                                                    {dateFilterDropdown && (
                                                                        <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
                                                                            <label className="form-label">From</label>
                                                                            <input type="date" className="form-control mb-2" name="from" value={startDateFilter} onChange={(e) => setStartDateFilter(e.target.value)} />

                                                                            <label className="form-label">To</label>
                                                                            <input type="date" className="form-control mb-2" name="to" value={endDateFilter} onChange={(e) => setEndDateFilter(e.target.value)} />

                                                                            <div className="text-end mt-3 d-flex justify-content-end">
                                                                                <button className="btn btn-primary btn-sm me-2" style={{ width: '80px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={applyDateFilterIn}>
                                                                                    Apply
                                                                                </button>
                                                                                <button className="btn btn-secondary btn-sm" style={{ width: '80px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => {
                                                                                    setStartDateFilter('');
                                                                                    setEndDateFilter('');
                                                                                }}>
                                                                                    Clear
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </th>




                                                            <th className="align-middle">Invoice No</th>
                                                            <th className="align-middle account-column">Client

                                                            </th>
                                                            <th className="align-middle">Amount</th>
                                                            <th className="align-middle">5% VAT</th>
                                                            <th className="align-middle">Total Amount</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invatData.length > 0 ? (
                                                            invatData.map((invat, index) => (
                                                                <tr key={invat.id}>
                                                                    <td>
                                                                        <div className="form-check font-size-16">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`transactionCheck${index}`}
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor={`transactionCheck${index}`}
                                                                            ></label>
                                                                        </div>
                                                                    </td>
                                                                    <td>{index + 1}</td>

                                                                    <td>{invat["Date"]}</td>
                                                                    <td>{invat["Invoice No"]}</td>
                                                                    <td>{invat["Client"]}</td>
                                                                    <td>{invat["Amount"]}</td>
                                                                    <td>{invat["5% VAT"]}</td>
                                                                    <td>
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                                <Tooltip id={`tooltip-invat-${invat.id}`} className="transaction-tooltip">
                                                                                    <div className="text-start p-1" style={{ minWidth: '180px' }}>
                                                                                        {/* 1. BANK FEE & GUARANTEE DETAILS */}
                                                                                        {(Number(invat.bank_service_charge || 0) > 0 || 
                                                                                          Number(invat.bank_vat_amount || 0) > 0 ||
                                                                                          Number(invat.commission_fee || 0) > 0 ||
                                                                                          Number(invat.commission_vat || 0) > 0) && (
                                                                                             <div className="mb-2 border-bottom border-secondary pb-1">
                                                                                                 <div className="font-size-11 text-uppercase fw-bold text-info border-bottom mb-1 pb-1">Fee & Guarantee Details</div>
                                                                                                 <div className="d-flex justify-content-between">
                                                                                                     <span>Base Amount:</span>
                                                                                                     <span className="fw-bold">{formatCurrency(invat.amount || invat["Amount"])}</span>
                                                                                                 </div>
                                                                                                 
                                                                                                 {/* BG Details */}
                                                                                                 {(Number(invat.commission_fee || 0) > 0 || Number(invat.commission_vat || 0) > 0) && (
                                                                                                     <div className="mt-1 border-top border-soft-secondary pt-1 font-size-11">
                                                                                                         {Number(invat.commission_fee || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Commission:</span>
                                                                                                                 <span className="text-info fw-bold">+{formatCurrency(invat.commission_fee)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                         {Number(invat.commission_vat || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Comm. VAT:</span>
                                                                                                                 <span className="text-info">+{formatCurrency(invat.commission_vat)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                     </div>
                                                                                                 )}

                                                                                                 {/* Standard Charges */}
                                                                                                 {(Number(invat.bank_service_charge || 0) > 0 || Number(invat.bank_vat_amount || 0) > 0) && (
                                                                                                     <div className="mt-1 border-top border-soft-secondary pt-1 font-size-11">
                                                                                                         {Number(invat.bank_service_charge || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Bank Charge:</span>
                                                                                                                 <span className="text-info fw-bold">+{formatCurrency(invat.bank_service_charge)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                         {Number(invat.bank_vat_amount || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Bank VAT:</span>
                                                                                                                 <span className="text-info">+{formatCurrency(invat.bank_vat_amount)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                     </div>
                                                                                                 )}
                                                                                             </div>
                                                                                         )}

                                                                                        {/* 2. ADVANCE APPLIED */}
                                                                                        {Number(invat.applied_advance || 0) > 0 && (
                                                                                            <div className="mb-2 border-bottom border-secondary pb-1 font-size-11">
                                                                                                <div className="d-flex justify-content-between fw-bold border-bottom mb-1 pb-1 text-uppercase text-warning">Advance Applied</div>
                                                                                                <div className="d-flex justify-content-between">
                                                                                                    <span>Total Settlement:</span>
                                                                                                    <span className="fw-bold">{formatCurrency(Number(invat.amount || invat["Amount"] || 0) + Number(invat.applied_advance || 0))}</span>
                                                                                                </div>
                                                                                                <div className="d-flex justify-content-between text-warning-soft">
                                                                                                    <span><i className="bx bx-right-arrow-alt"></i> Applied Advance:</span>
                                                                                                    <span>-{formatCurrency(invat.applied_advance)}</span>
                                                                                                </div>
                                                                                                <div className="d-flex justify-content-between text-info-soft border-top border-soft-secondary mt-1 pt-1">
                                                                                                    <span>Net Cash Flow:</span>
                                                                                                    <span>{formatCurrency(invat.amount || invat["Amount"])}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* 3. EXPENSE/INVOICE BREAKDOWN */}
                                                                                        {invat.transaction_expense_items && invat.transaction_expense_items.length > 0 && (
                                                                                            <div className="mb-1">
                                                                                                <div className="font-size-11 text-uppercase fw-bold text-danger border-bottom mb-1 pb-1">Applied Bills</div>
                                                                                                {invat.transaction_expense_items.map((item, idx) => {
                                                                                                    const billCurrency = item.expense?.vendor_currency || 'AED';
                                                                                                    const transCurrency = invat.currency?.currency || 'AED';
                                                                                                    const billTotal = Number(item.expense?.total_amount || 0);
                                                                                                    const paidInThisTransRaw = Number(item.paid_amount || 0);
                                                                                                    
                                                                                                    let paidInBillCurrency = paidInThisTransRaw;
                                                                                                    const billExchangeRate = Number(item.expense?.exchange_rate || 3.672);
                                                                                                    
                                                                                                    if (billCurrency !== transCurrency) {
                                                                                                        if (billCurrency === 'USD' && transCurrency === 'AED') paidInBillCurrency = paidInThisTransRaw / billExchangeRate;
                                                                                                        else if (billCurrency === 'AED' && transCurrency === 'USD') paidInBillCurrency = paidInThisTransRaw * billExchangeRate;
                                                                                                    }

                                                                                                    return (
                                                                                                        <div key={idx} className="mb-2 last-child-mb-0 border-soft-bottom pb-1">
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span>{item.expense?.invoice_no || 'Expense'}</span>
                                                                                                                <span className="text-muted">Total: {billCurrency} {formatCurrency(billTotal)}</span>
                                                                                                            </div>
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span className="text-danger">Paid:</span>
                                                                                                                <span className="text-danger">-{billCurrency} {formatCurrency(paidInBillCurrency)}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                                {invat.transaction_expense_items.length > 1 && (
                                                                                                    <div className="mt-2 pt-1 border-top border-danger border-2">
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold">
                                                                                                            <span>Combined Total:</span>
                                                                                                            <span>{formatCurrency(invat.transaction_expense_items.reduce((s, i) => s + Number(i.expense?.total_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold text-danger">
                                                                                                            <span>Total Paid:</span>
                                                                                                            <span>-{formatCurrency(invat.transaction_expense_items.reduce((s, i) => s + Number(i.paid_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        )}

                                                                                        {invat.transaction_invoice_items && invat.transaction_invoice_items.length > 0 && (
                                                                                            <div className="mb-1">
                                                                                                <div className="font-size-11 text-uppercase fw-bold text-success border-bottom mb-1 pb-1">Applied Invoices</div>
                                                                                                {invat.transaction_invoice_items.map((item, idx) => {
                                                                                                    const invCurrency = item.invoice?.client_currency || 'AED';
                                                                                                    const transCurrency = invat.currency?.currency || 'AED';
                                                                                                    const invTotal = Number(item.invoice?.total_amount || 0);
                                                                                                    const paidInThisTransRaw = Number(item.paid_amount || 0);
                                                                                                    
                                                                                                    let paidInInvCurrency = paidInThisTransRaw;
                                                                                                    const invExchangeRate = Number(item.invoice?.exchange_rate || 3.672);
                                                                                                    
                                                                                                    if (invCurrency !== transCurrency) {
                                                                                                        if (invCurrency === 'USD' && transCurrency === 'AED') paidInInvCurrency = paidInThisTransRaw / invExchangeRate;
                                                                                                        else if (invCurrency === 'AED' && transCurrency === 'USD') paidInInvCurrency = paidInThisTransRaw * invExchangeRate;
                                                                                                    }

                                                                                                    return (
                                                                                                        <div key={idx} className="mb-2 last-child-mb-0 border-soft-bottom pb-1">
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span>{item.invoice?.invoice_no || 'Invoice'}</span>
                                                                                                                <span className="text-muted">Total: {invCurrency} {formatCurrency(invTotal)}</span>
                                                                                                            </div>
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span className="text-success">Received:</span>
                                                                                                                <span className="text-success">+{invCurrency} {formatCurrency(paidInInvCurrency)}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                                {invat.transaction_invoice_items.length > 1 && (
                                                                                                    <div className="mt-2 pt-1 border-top border-success border-2">
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold">
                                                                                                            <span>Combined Total:</span>
                                                                                                            <span>{formatCurrency(invat.transaction_invoice_items.reduce((s, i) => s + Number(i.invoice?.total_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold text-success">
                                                                                                            <span>Total Received:</span>
                                                                                                            <span>+{formatCurrency(invat.transaction_invoice_items.reduce((s, i) => s + Number(i.paid_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        )}

                                                                                        {!invat.bank_service_charge && !invat.transaction_expense_items && !invat.transaction_invoice_items && !invat.applied_advance && !invat.commission_fee && (
                                                                                            <span>Total: {invat["Total Amount"]}</span>
                                                                                        )}
                                                                                    </div>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <span className="fw-bold cursor-pointer underline-on-hover">
                                                                                {invat["Total Amount"]}
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    </td>

                                                                    {/* <td>{transaction.category?.name||transaction.project?.name}</td> */}

                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9">No transactions found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {/* <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {transactions.length} entries</span> */}
                                                <div className="d-flex justify-content-end pagination-sm">
                                                    {inputVatPagination.pageCount > 0 && (
                                                        <ReactPaginate
                                                            previousLabel={'<'}
                                                            nextLabel={'>'}
                                                            breakLabel={'...'}
                                                            pageCount={inputVatPagination.pageCount}
                                                            forcePage={inputVatPage - 1}
                                                            marginPagesDisplayed={2}
                                                            pageRangeDisplayed={3}
                                                            onPageChange={handleInputVatPageChange}
                                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                            pageClassName={'page-item'}
                                                            pageLinkClassName={'page-link'}
                                                            previousClassName={'page-item previous'}
                                                            previousLinkClassName={'page-link'}
                                                            nextClassName={'page-item next'}
                                                            nextLinkClassName={'page-link'}
                                                            breakClassName={'page-item'}
                                                            breakLinkClassName={'page-link'}
                                                            activeClassName={'active'}
                                                        />
                                                    )}
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>

                                        <div className={`tab-pane ${activeTab === 'output-vat' ? 'show active' : ''}`} id="output-vat" role="tabpanel">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div className="d-flex">
                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                        {/* <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control font-size-12"
                                                                placeholder="Search..."
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                            />
                                                            <i className="bx bx-search-alt search-icon" />
                                                        </div> */}
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="dropdown icon-button">
                                                        <button
                                                            className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"
                                                            type="button"
                                                            id="quarterFilter"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-calendar icon-style" title="Filter by Quarter"></i>
                                                        </button>
                                                        <ul className="dropdown-menu" aria-labelledby="quarterFilter">
                                                            {quarterOptions.map((q, index) => (
                                                                <li key={index}>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => {
                                                                            setSelectedQuarterLabel(q.label);
                                                                            setStartDateFilter(q.from);
                                                                            setEndDateFilter(q.to);
                                                                            fetchvatData('output', 1, 15, q.from, q.to);
                                                                        }}
                                                                    >
                                                                        {q.label}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        className="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center"
                                                        onClick={() => downloadVATReport()}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Generate Report"
                                                        disabled={loading}
                                                    >
                                                        <FiDownload size={18} className="text-primary" />
                                                    </button>



                                                </div>


                                            </div>
                                            <div>
                                                <table className="table align-middle table-nowrap table-check table-list">

                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th style={{ width: '20px' }} className="align-middle">
                                                                <div className="form-check font-size-16">
                                                                    <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                    <label className="form-check-label" htmlFor="checkAll"></label>
                                                                </div>
                                                            </th>
                                                            <th className="align-middle">#</th>
                                                            <th className="align-middle">
                                                                Date
                                                                <div className="dropdown d-inline-block">
                                                                    <FaFilter
                                                                        className="ms-2 cursor-pointer filter-color"
                                                                        onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
                                                                    />
                                                                    {dateFilterDropdown && (
                                                                        <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
                                                                            <label className="form-label">From</label>
                                                                            <input type="date" className="form-control mb-2" name="from" value={startDateFilter} onChange={(e) => setStartDateFilter(e.target.value)} />

                                                                            <label className="form-label">To</label>
                                                                            <input type="date" className="form-control mb-2" name="to" value={endDateFilter} onChange={(e) => setEndDateFilter(e.target.value)} />

                                                                            <div className="text-end mt-3 d-flex justify-content-end">
                                                                                <button className="btn btn-primary btn-sm me-2" style={{ width: '80px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={applyDateFilterOu}>
                                                                                    Apply
                                                                                </button>
                                                                                <button className="btn btn-secondary btn-sm" style={{ width: '80px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => {
                                                                                    setStartDateFilter('');
                                                                                    setEndDateFilter('');
                                                                                }}>
                                                                                    Clear
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </th>




                                                            <th className="align-middle">Invoice No</th>
                                                            <th className="align-middle account-column">Vendor

                                                            </th>
                                                            <th className="align-middle">Taxable Amount</th>
                                                            <th className="align-middle">5% VAT</th>
                                                            <th className="align-middle">Non-Taxable Amount</th>

                                                            <th className="align-middle">Total Amount</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {ouvatData.length > 0 ? (
                                                            ouvatData.map((ouvat, index) => (
                                                                <tr key={ouvat.id}>
                                                                    <td>
                                                                        <div className="form-check font-size-16">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`transactionCheck${index}`}
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor={`transactionCheck${index}`}
                                                                            ></label>
                                                                        </div>
                                                                    </td>
                                                                    <td>{index + 1}</td>

                                                                    <td>{ouvat["Date"]}</td>
                                                                    <td>{ouvat["Invoice No"]}</td>
                                                                    <td>{ouvat["Vendor\/Client"]}</td>
                                                                    <td>{ouvat["Taxable Amount"]}</td>
                                                                    <td>{ouvat["5% VAT"]}</td>
                                                                    <td>{ouvat["Non-Taxable Amount"]}</td>
                                                                    <td>
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={
                                                                                <Tooltip id={`tooltip-ouvat-${ouvat.id}`} className="transaction-tooltip">
                                                                                    <div className="text-start p-1" style={{ minWidth: '180px' }}>
                                                                                        {/* 1. BANK FEE & GUARANTEE DETAILS */}
                                                                                        {(Number(ouvat.bank_service_charge || 0) > 0 || 
                                                                                          Number(ouvat.bank_vat_amount || 0) > 0 ||
                                                                                          Number(ouvat.commission_fee || 0) > 0 ||
                                                                                          Number(ouvat.commission_vat || 0) > 0) && (
                                                                                             <div className="mb-2 border-bottom border-secondary pb-1">
                                                                                                 <div className="font-size-11 text-uppercase fw-bold text-info border-bottom mb-1 pb-1">Fee & Guarantee Details</div>
                                                                                                 <div className="d-flex justify-content-between">
                                                                                                     <span>Base Amount:</span>
                                                                                                     <span className="fw-bold">{formatCurrency(ouvat.amount || ouvat["Taxable Amount"])}</span>
                                                                                                 </div>
                                                                                                 
                                                                                                 {/* BG Details */}
                                                                                                 {(Number(ouvat.commission_fee || 0) > 0 || Number(ouvat.commission_vat || 0) > 0) && (
                                                                                                     <div className="mt-1 border-top border-soft-secondary pt-1 font-size-11">
                                                                                                         {Number(ouvat.commission_fee || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Commission:</span>
                                                                                                                 <span className="text-info fw-bold">+{formatCurrency(ouvat.commission_fee)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                         {Number(ouvat.commission_vat || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Comm. VAT:</span>
                                                                                                                 <span className="text-info">+{formatCurrency(ouvat.commission_vat)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                     </div>
                                                                                                 )}

                                                                                                 {/* Standard Charges */}
                                                                                                 {(Number(ouvat.bank_service_charge || 0) > 0 || Number(ouvat.bank_vat_amount || 0) > 0) && (
                                                                                                     <div className="mt-1 border-top border-soft-secondary pt-1 font-size-11">
                                                                                                         {Number(ouvat.bank_service_charge || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Bank Charge:</span>
                                                                                                                 <span className="text-info fw-bold">+{formatCurrency(ouvat.bank_service_charge)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                         {Number(ouvat.bank_vat_amount || 0) > 0 && (
                                                                                                             <div className="d-flex justify-content-between">
                                                                                                                 <span>Bank VAT:</span>
                                                                                                                 <span className="text-info">+{formatCurrency(ouvat.bank_vat_amount)}</span>
                                                                                                             </div>
                                                                                                         )}
                                                                                                     </div>
                                                                                                 )}
                                                                                             </div>
                                                                                         )}

                                                                                        {/* 2. ADVANCE APPLIED */}
                                                                                        {Number(ouvat.applied_advance || 0) > 0 && (
                                                                                            <div className="mb-2 border-bottom border-secondary pb-1 font-size-11">
                                                                                                <div className="d-flex justify-content-between fw-bold border-bottom mb-1 pb-1 text-uppercase text-warning">Advance Applied</div>
                                                                                                <div className="d-flex justify-content-between">
                                                                                                    <span>Total Settlement:</span>
                                                                                                    <span className="fw-bold">{formatCurrency(Number(ouvat.amount || ouvat["Taxable Amount"] || 0) + Number(ouvat.applied_advance || 0))}</span>
                                                                                                </div>
                                                                                                <div className="d-flex justify-content-between text-warning-soft">
                                                                                                    <span><i className="bx bx-right-arrow-alt"></i> Applied Advance:</span>
                                                                                                    <span>-{formatCurrency(ouvat.applied_advance)}</span>
                                                                                                </div>
                                                                                                <div className="d-flex justify-content-between text-info-soft border-top border-soft-secondary mt-1 pt-1">
                                                                                                    <span>Net Cash Flow:</span>
                                                                                                    <span>{formatCurrency(ouvat.amount || ouvat["Taxable Amount"])}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* 3. EXPENSE/INVOICE BREAKDOWN */}
                                                                                        {ouvat.transaction_expense_items && ouvat.transaction_expense_items.length > 0 && (
                                                                                            <div className="mb-1">
                                                                                                <div className="font-size-11 text-uppercase fw-bold text-danger border-bottom mb-1 pb-1">Applied Bills</div>
                                                                                                {ouvat.transaction_expense_items.map((item, idx) => {
                                                                                                    const billCurrency = item.expense?.vendor_currency || 'AED';
                                                                                                    const transCurrency = ouvat.currency?.currency || 'AED';
                                                                                                    const billTotal = Number(item.expense?.total_amount || 0);
                                                                                                    const paidInThisTransRaw = Number(item.paid_amount || 0);
                                                                                                    
                                                                                                    let paidInBillCurrency = paidInThisTransRaw;
                                                                                                    const billExchangeRate = Number(item.expense?.exchange_rate || 3.672);
                                                                                                    
                                                                                                    if (billCurrency !== transCurrency) {
                                                                                                        if (billCurrency === 'USD' && transCurrency === 'AED') paidInBillCurrency = paidInThisTransRaw / billExchangeRate;
                                                                                                        else if (billCurrency === 'AED' && transCurrency === 'USD') paidInBillCurrency = paidInThisTransRaw * billExchangeRate;
                                                                                                    }

                                                                                                    return (
                                                                                                        <div key={idx} className="mb-2 last-child-mb-0 border-soft-bottom pb-1">
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span>{item.expense?.invoice_no || 'Expense'}</span>
                                                                                                                <span className="text-muted">Total: {billCurrency} {formatCurrency(billTotal)}</span>
                                                                                                            </div>
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span className="text-danger">Paid:</span>
                                                                                                                <span className="text-danger">-{billCurrency} {formatCurrency(paidInBillCurrency)}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                                {ouvat.transaction_expense_items.length > 1 && (
                                                                                                    <div className="mt-2 pt-1 border-top border-danger border-2">
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold">
                                                                                                            <span>Combined Total:</span>
                                                                                                            <span>{formatCurrency(ouvat.transaction_expense_items.reduce((s, i) => s + Number(i.expense?.total_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold text-danger">
                                                                                                            <span>Total Paid:</span>
                                                                                                            <span>-{formatCurrency(ouvat.transaction_expense_items.reduce((s, i) => s + Number(i.paid_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        )}

                                                                                        {ouvat.transaction_invoice_items && ouvat.transaction_invoice_items.length > 0 && (
                                                                                            <div className="mb-1">
                                                                                                <div className="font-size-11 text-uppercase fw-bold text-success border-bottom mb-1 pb-1">Applied Invoices</div>
                                                                                                {ouvat.transaction_invoice_items.map((item, idx) => {
                                                                                                    const invCurrency = item.invoice?.client_currency || 'AED';
                                                                                                    const transCurrency = ouvat.currency?.currency || 'AED';
                                                                                                    const invTotal = Number(item.invoice?.total_amount || 0);
                                                                                                    const paidInThisTransRaw = Number(item.paid_amount || 0);
                                                                                                    
                                                                                                    let paidInInvCurrency = paidInThisTransRaw;
                                                                                                    const invExchangeRate = Number(item.invoice?.exchange_rate || 3.672);
                                                                                                    
                                                                                                    if (invCurrency !== transCurrency) {
                                                                                                        if (invCurrency === 'USD' && transCurrency === 'AED') paidInInvCurrency = paidInThisTransRaw / invExchangeRate;
                                                                                                        else if (invCurrency === 'AED' && transCurrency === 'USD') paidInInvCurrency = paidInThisTransRaw * invExchangeRate;
                                                                                                    }

                                                                                                    return (
                                                                                                        <div key={idx} className="mb-2 last-child-mb-0 border-soft-bottom pb-1">
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span>{item.invoice?.invoice_no || 'Invoice'}</span>
                                                                                                                <span className="text-muted">Total: {invCurrency} {formatCurrency(invTotal)}</span>
                                                                                                            </div>
                                                                                                            <div className="d-flex justify-content-between font-size-11">
                                                                                                                <span className="text-success">Received:</span>
                                                                                                                <span className="text-success">+{invCurrency} {formatCurrency(paidInInvCurrency)}</span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                                {ouvat.transaction_invoice_items.length > 1 && (
                                                                                                    <div className="mt-2 pt-1 border-top border-success border-2">
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold">
                                                                                                            <span>Combined Total:</span>
                                                                                                            <span>{formatCurrency(ouvat.transaction_invoice_items.reduce((s, i) => s + Number(i.invoice?.total_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                        <div className="d-flex justify-content-between font-size-11 fw-bold text-success">
                                                                                                            <span>Total Received:</span>
                                                                                                            <span>+{formatCurrency(ouvat.transaction_invoice_items.reduce((s, i) => s + Number(i.paid_amount || 0), 0))}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        )}

                                                                                        {!ouvat.bank_service_charge && !ouvat.transaction_expense_items && !ouvat.transaction_invoice_items && !ouvat.applied_advance && !ouvat.commission_fee && (
                                                                                            <span>Total: {ouvat["Total Amount"]}</span>
                                                                                        )}
                                                                                    </div>
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <span className="fw-bold cursor-pointer underline-on-hover">
                                                                                {ouvat["Total Amount"]}
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9">No transactions found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {/* <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {transactions.length} entries</span> */}
                                                <div className="d-flex justify-content-end pagination-sm">
                                                    {outputVatPagination.pageCount > 0 && (
                                                        <ReactPaginate
                                                            previousLabel={'<'}
                                                            nextLabel={'>'}
                                                            breakLabel={'...'}
                                                            pageCount={outputVatPagination.pageCount}
                                                            forcePage={outputVatPage - 1}
                                                            marginPagesDisplayed={2}
                                                            pageRangeDisplayed={3}
                                                            onPageChange={handleOutputVatPageChange}
                                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                            pageClassName={'page-item'}
                                                            pageLinkClassName={'page-link'}
                                                            previousClassName={'page-item previous'}
                                                            previousLinkClassName={'page-link'}
                                                            nextClassName={'page-item next'}
                                                            nextLinkClassName={'page-link'}
                                                            breakClassName={'page-item'}
                                                            breakLinkClassName={'page-link'}
                                                            activeClassName={'active'}
                                                        />
                                                    )}
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <TransactionModal
                        key={selectedTransactionId || 'new'}
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        transactionId={selectedTransactionId}
                        transactionData={selectedTransactionData}
                        addTransaction={addTransaction}
                        editTransaction={editTransaction}
                        transactions={transactions}
                        errors={errors}
                        setErrors={setErrors}
                        clients={clients}
                        fetchClients={fetchClients}
                        projects={projects}
                        fetchProjects={fetchProjects}
                        categories={categories}
                        fetchCategories={fetchCategories}
                        banks={banks}
                        fetchBanks={fetchBanks}
                        vendors={vendors}
                        fetchVendors={fetchVendors}
                        setBanks={setBanks}
                        users={users}
                        fetchUsers={fetchUsers}
                        isEditMode={isEditMode}
                        setIsEditMode={setIsEditMode}
                    />
                </div>
            </div>
        </div>
    );
};

export default TransactionList;

